import { Injectable } from '@angular/core';
import { TranslateLoader } from '@ngx-translate/core';
import { Observable, of } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class MiTranslateLoaderService implements TranslateLoader {

  getTranslation(): Observable<any> {
    return of({
      Username: 'Email Address',
      Username_or_Email: 'Email/Username',
      Password: 'Password',
      lbl_dispatch_date: 'Are you sure you want to change the dispatch date?',
      lbl_dispatch_date_required: 'Dispatch date is required',
      placeholder_email: 'Enter Email/Username',
      lbl_enter_password: 'Enter password',
      lbl_dispatch_date_msg: 'The dispatch date has been updated.',
      'Username is should be greater than x': 'Username must be at least {{minval}} characters long',
      forgot_password: 'Forgot Password',
      login_success: 'Login successful. Welcome back.',
      login_first_success: 'Login again with updated password.',
      logout_success: 'You have been successfully logged out.',
      lbl_min_length_password: 'Password should be minimum 8 characters.',
      lbl_max_length_password: 'Password should be maximum 20 characters.',
      email_placeholder: 'Enter email address',
      email_request: 'Please enter your email address to receive a password reset link.',
      lbl_remember_me: 'Remember me',
      lbl_logo_rights: '© Akesa 2025. All rights reserved',
      lbl_powered_by: 'Powered by',
      lbl_forget_password: 'Forgot Password',
      forgot_password_link: 'Password reset link has been sent successfully',
      reset_request: 'Please enter your new password',
      lbl_reset_passowrd: 'Password',
      lbl_reset_confirm_passowrd: 'Confirm Password',
      set_password: 'Set Password',
      lbl_password_change_message: 'Your password has been updated successfully',
      lbl_password_character_error: 'Password must contain at least one uppercase letter, one lowercase letter, one number, and one special character.',
      lbl_password_required: 'Password is required',
      lbl_password_match: 'Passwords must match',
      lbl_passenger: 'Passenger',
      lbl_invalid_email_format: 'Please enter a valid email address.',
      lbl_email_too_long: 'Email length should not exceed 254 characters',
      lbl_local_part_too_long: 'Local part should not exceed 64 characters',
      lbl_email_address: 'Please enter email address',
      view_document: 'View Document',
      lbl_start_date: 'Select start date',
      lbl_end_date: 'Select end date',
      lbl_quantity_exceed_msg: 'In-stock quantity cannot exceed required quantity',
      lbl_product_in_stock_required: 'Enter product in stock',
      lbl_unit_cost_required: 'Unit cost is required',
      lbl_min_length: 'Minimum length should be 2 characters.',
      lbl_max_length: 'Maximum length should be 30 characters.',
      lbl_white_spaces: 'Supplier reference cannot be only spaces.',
      lbl_pack_size: 'Pack Size',
      lbl_pack_type: 'Pack Type',
      lbl_remaining_date_should_be_after_in_stock_date: "The dispatch date for the remaining products must be the same or later than the dispatch date for in-stock products.",
      lbl_placeholder_review: 'Search by protocol name/number ',
      error_leading_trailing_white_spaces: 'Leading or trailing spaces are not allowed.',
      lbl_other: 'Other',
      lbl_description: 'Enter other reason',
      lbl_back_order: 'Back Order',
      lbl_max_limit_exceeded: 'Maximum allowed quantity is 999999',
      error_loading_notifications: 'Failed to load notifications. Please try again.',
      lbl_bulk_import_error: 'Verification failed',

      lbl_max_files_limit_reached: 'Maximum file limit reached',
      delivery_time: {
        start_time_before_end: 'Start time must be before end time',
        end_time_after_start: 'End time must be after start time'
      },

      grid_title: 'TITLE',
      grid_trial_start_date: 'START DATE',
      grid_trail_end_date: 'END DATE',
      grid_patients: 'PATIENTS',
      lbl_no_records_found: 'No records found',
      lbl_enter_labels: 'Enter Labels',
      lbl_serial_number: 'Sr. No.',
      lbl_no_patients_found: 'No patients found',
      lbl_close: 'Close',
      lbl_processing: 'Processing',

      sidebar_lbl_dashboard: 'Dashboard',
      sidebar_lbl_events: 'Events',
      sidebar_lbl_manage_groups: 'Manage Groups',
      sidebar_lbl_manage_employees: 'Manage Employees',
      sidebar_lbl_home: 'Home',
      sidebar_lbl_trials: 'Trials',
      sidebar_lbl_orders: 'Orders',
      sidebar_lbl_products: 'Products',
      sidebar_lbl_sponsors: 'Sponsors',
      sidebar_lbl_sites: 'Sites',
      sidebar_lbl_users: 'Users',
      sidebar_lbl_reports: 'Reports',
      sidebar_lbl_settings: 'Settings',
      sidebar_lbl_system: 'System',
      sidebar_contact_us: 'Contact Us',
      sidebar_privacy_policy: 'Privacy Policy',
      lbl_sponsor_address: 'Sponsor Address',
      lbl_export_success_msg: 'Success! Your file has been successfully exported. Check your email for a link to download the Excel file.',


      header_logout_confirmation: 'Logout Confirmation',

      msg_logout: '<p><b>Are you sure you want to log out?</b></p>\n\nLogging out will end your current session. Please ensure all your work is saved before proceeding. You will need to sign in again to access the system.',
      lbl_confirm_idle_session: `Your session has been idle for an extended period and will be automatically terminated in 2 minutes. Click "Yes" to continue your session.`,

      manage_column_header: 'Manage Columns',
      manage_column_sub_header: 'Select which columns are visible in your view. You can reorder columns by dragging and dropping the visible fields.',
      manage_column_available_columns: 'Available Columns',
      manage_column_visible_columns: 'Visible Columns',
      manage_column_restore_default: 'Restore defaults',
      manage_column_apply_changes: 'Apply Changes',
      cancel: 'Cancel',
      reset: "Reset",
      label_save: 'Save',
      label_update: 'Update',
      lbl_reset: 'Reset',
      lbl_confirm_action: 'Confirm Action',
      please_type_reset_to_confirm: 'Please type "RESET" to confirm this action',
      error_type_reset: 'Please enter "RESET" to proceed',
      password_reset_success: 'Password has been reset successfully',
      lbl_warning: 'WARNING: This action will require all users to change their password upon their next login.',
      lbl_text_for_download_data: 'Export a copy of your account data for backup purposes or to use with other reporting services. This process may take several minutes depending on the amount of data.',
      lbl_note_for_download_date: 'You will receive an email notification when your export file is ready for download. For security reasons, the download link will expire after 7 days.',
      lbl_text_for_password_requirement: 'Configure the security requirements for user passwords in your portal',
      lbl_note_for_password_requirement: 'These requirements apply to new password creation and password resets. Use the "Reset All Passwords" option to require all users to change their password upon their next login. Note: These requirements do not affect passwords managed through external authentication systems (e.g., SAML, Okta, Google).',
      lbl_text_for_session_timeout: 'Configure how long users can remain inactive before being automatically signed out.',
      clear_all: 'Clear all',
      add_event: 'Add Event',
      add_vehicle: 'Add Vehicle',
      lbl_selected: 'Selected',
      lbl_name: 'Name',
      lbl_email: 'Email',
      lbl_user_role: 'User Role',
      lbl_username: 'Username',
      lbl_new_password: 'New Password',
      ph_new_password: 'Enter New Password',
      lbl_confirm_password: 'Confirm Password',
      ph_confirm_password: 'Confirm New Password',
      lbl_phone_number: 'Phone Number',
      lbl_user_status: 'User Status',
      lbl_new_user: 'New User',
      lbl_create_new: 'Create New',
      lbl_role_name: 'Role Name',
      lbl_role_code: 'Role Code',
      lbl_created_by: 'Created By',
      lbl_created_on: 'Created On',
      lbl_modified_by: 'Modified By',
      lbl_modified_on: 'Modified On',
      lbl_f_name: 'First Name',
      lbl_l_name: 'Last Name',
      lbl_country_code: 'Country Code',
      lbl_user_details: 'User Details',
      search_by_body_type: 'Search by Body Type',
      select_body_type: 'Select Body Type',
      filters_lbl: 'Filters',
      close_filter: 'Close',
      items_per_page: 'Items Per Page',
      lbl_details: 'Details',
      lbl_files: 'Files',
      lbl_all: 'All',
      lbl_active: 'Active',
      lbl_inactive: 'Inactive',
      lbl_assigned: 'Assigned',
      lbl_unassigned: 'Unassigned',
      lbl_deleted: 'Deleted',
      lbl_search: 'Search',
      lbl_action: 'Action',
      lbl_actions: 'Actions',
      lbl_restore_defaults: 'Restore defaults',
      lbl_apply: 'Apply',
      lbl_clear_all: 'Clear all',
      clear_selection: 'Clear Selection',
      lbl_select_status: 'Select Status',
      lbl_update_vehicles: 'Update Vehicles',
      bulk_row_sub_header: 'You have selected',
      bulk_row_sub_header2: 'The new value for the selected fields will be applied to all selected',
      lbl_field_upper: 'FIELD',
      lbl_value_upper: 'VALUE',
      lbl_messaging: 'Messaging',
      lbl_broadcasting: 'Broadcasting',
      lbl_manage_segments: 'Manage Segments',
      customize_feeds: 'Customize Feeds',
      lbl_type_a_message: 'Type a message...',
      quick_call_text: 'Hi, can we have a quick call? its related to vehicles.',
      lbl_mentioned_you: 'mentioned you',
      lbl_seen: 'Seen',
      lbl_hide: 'Hide',
      lbl_sent: 'Sent',
      lbl_add_field: 'Add Field',
      lbl_continue_to_review: 'Continue to Review',
      lbl_field: 'Field',
      lbl_value: 'Value',
      review_bulk_row_sub_header: 'Please review the summary of changes you are about to make to',
      review_bulk_row_sub_header2: 'Do you wish to continue?',
      lbl_review_vehicles: 'Review Vehicles',
      btn_update_vehicles: 'Update',
      btn_update_vehicles2: 'Vehicle',
      btn_passengers: 'Passengers',
      btn_passenger: 'Passenger',
      lbl_max: 'Max',
      lbl_please_select: 'Please Select',
      lbl_select: 'Please Select',
      lbl_select_only: 'Select',
      placeholder_search: 'Search',
      placeholder_search_by: 'Search by',
      lbl_select_sponsor: 'Select sponsor',
      lbl_no_results_to_show: 'No results to show.',
      lbl_no_records_available1: 'It looks like there are currently no records ',
      lbl_no_records_available2: 'available for this view.',
      no_records_to_show: 'It looks like there are currently no records available for this view.',
      lbl_img_pdf_upload_instruction: 'Accepted file formats: JPG, PNG, PDF (Maximum file size: 10MB)',
      lbl_img_upload_instruction: 'Accepted file formats: JPG, JPEG, PNG (Maximum file size: 10MB)',
      accepted_file_format_for_image: 'Accepted format JPG, JPEG, PNG. Please upload again',
      accepted_file_format_for_doc: 'Accepted format JPG, PNG, PDF. Please upload again',
      lbl_select_document: 'Select Document',
      lbl_select_image: 'Select Image',
      lbl_select_logo: 'Select Logo',
      err_file_size_exceed_msg: 'File size should not be more than 10MB.',
      err_image_upload_format: 'Please upload an image in PNG, JPG, or JPEG format.',
      lbl_drop_img: 'Or drop image here',
      lbl_drop_logo: 'Or drop logo here',
      lbl_drop_document: 'Or drop document here',
      lbl_file_uploaded_successfully: 'File uploaded successfully',
      lbl_img_uploaded_successfully: 'File Uploaded Successfully',
      lbl_file_download_successfully: 'File downloaded successfully',
      lbl_barcode_download_successfully: 'Barcode downloaded successfully',
      lbl_empty: '--',
      lbl_add_more_locations: 'Add More Locations',
      lbl_add_more: 'Add More',
      lbl_btn_previous: 'Previous',
      lbl_next_btn: 'Next',
      lbl_add: 'Add',
      lbl_save: 'Save',
      lbl_yes: 'Yes',
      lbl_no: 'No',
      lbl_delete: 'Delete',
      sidebar_shift_template: 'Shift Template',
      add_new: 'Add New',
      data_updated_successfully: 'Data Updated Successfully',
      lbl_breaks: ' Breaks',
      lbl_break: ' Break',
      lbl_select_date: 'Select Date',
      lbl_date_range: 'Select Date Range',
      lbl_drivers: 'Drivers',
      lbl_total_drivers: 'Total Drivers',
      location_already_added: 'Location Name Already Added.',
      record_is_deleted: 'Record is deleted',
      lbl_add_assignment: 'Add Assignment History',
      lbl_all_journey: 'All Journeys',
      lbl_reset_pass: 'Reset Password Successfully',
      lbl_reset_password: 'Reset Password',
      error_message_starttime: 'Break start time cannot be the same as shift start time',
      err_message_breaktime: 'Break start time cannot be after shift end time',
      err_mess_breaktime: 'Break start time cannot be before shift start time',
      err_mess_breakendtime: 'Break end time should be greater than shift start time',
      lbl_supplier_reference_number: 'Supplier Reference Number',
      lbl_supplier_reference_number_req: 'Supplier Reference Number is required',
      lbl_placeholder_reference_number: 'Enter Reference Number',
      lbl_date_of_dispatch: 'Date of Dispatch',
      lbl_date_of_dispatch_req: 'Date of Dispatch is required',
      lbl_expected_date_of_dispatch_req: 'Expected Date of Delivery is required',
      lbl_placeholder_date_of_dispatch: 'Select date',
      lbl_reason_for_rejection: 'Reason For Rejection',
      lbl_reason_for_cancellation: 'Reason For Cancellation',
      lbl_reason_for_cancellation_req: 'Reason For Cancellation is required',
      lbl_reason_for_rejection_req: 'Reason For Rejection is required',
      lbl_placeholder_reason_for_rejection: 'Enter Reason',
      lbl_ctn: 'CTN',
      lbl_products: 'Products',
      lbl_purchase_orders: 'Purchase Orders',
      lbl_expected_date: 'Expected Date: ',
      lbl_confirm: 'Confirm',
      lbl_expiry_date: 'Expiry',
      lbl_expected_delivery_date: 'Expected Delivery Date',
      lbl_short_delivered: 'Short Delivered (Incorrect Quantity)',
      lbl_product_expired: 'Expired Stock',
      lbl_damaged: 'Damaged',
      lbl_wrong_product_delivered: 'Wrong Product Received',
      lbl_order_zero_error_msg: 'At least one product must have quantity greater than 0.',
      lbl_parent_order: 'Parent Order: ',
      lbl_reset_first_password: 'Reset Your Password',
      lbl_reset_password_lbl: 'Reset Password',
      lbl_password_expiring_soon: 'Password Expiring Soon',
      lbl_password_expiring_warning: 'Your password will expire in 3 days. Please change your password to continue.',
      lbl_password_expired: 'Your password is expired. Please change the password to continue.',
      lbl_password_expiring_1_day: 'Your password will expire in 1 day. Please change your password to continue.',
      lbl_password_expiring_days: 'Your password will expire in {days} days. Please change your password to continue.',
      lbl_password_expiring_soon_header: 'Password Expiring Soon',
      lbl_awaiting_order: 'Awaiting Order Receive Confirmation',
      lbl_document_multiple: 'Only 5 documents are allowed',
      lbl_document_single: 'Only 1 document is allowed',
      lbl_skip_for_now: 'Skip for Now',
      placeholder_search_by_site: 'Search by Site',
      lbl_no_internet_connection: 'No internet connection. Please check your network settings and reload the page.',

      invalid: {
        breakTime: 'Invalid Break Time'
      },

      dashboard: {
        lbl_dashboard: 'Dashboard',
        lbl_total_number_of_orders: 'Total Orders',
        lbl_total_products: 'Total Products',
        lbl_total_sites: 'Total Sites',
        lbl_active_patient: 'Active Patient',
        lbl_budget_utilized: 'Budget Utilized',
        total_orders: 'Total Orders',
        lbl_pending_orders: 'Pending Orders',
        lbl_completed_orders: 'Completed Orders',
        lbl_rejected_orders: 'Cancelled Orders',
        lbl_total_protocols: 'Total Protocols',
        lbl_completed_protocols: 'Completed Protocols',
        lbl_running_protocols: 'Running Protocols',
        lbl_protocols: 'Protocols',
        lbl_total_number_of_sites: 'Total Sites',
        lbl_pending: 'Pending',
        lbl_completed: 'Completed',
        lbl_accepted: 'Accepted',
        lbl_rejected: 'Cancelled',
      },

      product: {
        lbl_products: 'Products',
        add_product: 'Add Product',
        lbl_archive: 'Archived',
        lbl_archive_dialog: 'Archive',
        lbl_unarchive_dialog: 'Unarchive',
        lbl_deleted: 'Deleted',
        lbl_all: 'All',
        lbl_product: 'Products',
        lbl_overview: 'Overview',
        lbl_product_details: 'Details',
        lbl_update_product: 'Update Product',
        lbl_save_product: 'Save Product',
        lbl_edit_product: 'Edit Product',
        lbl_edit: 'Edit',
        lbl_deactivate_address_error_msg: 'Primary address cannot be deactivated. Please assign another address as Primary before deactivating this one.',
        lbl_product_added_successfully: 'Product Added Successfully',
        lbl_product_updated_successfully: 'Product Updated Successfully',
        lbl_product_archived_successfully: 'Product Archived Successfully',
        lbl_product_unarchived_successfully: 'Product Unarchived Successfully',
        lbl_activate_successfully: 'Product Status Updated Successfully',
        lbl_product_archive_failed: 'Failed to Archive Product',
        lbl_product_unarchive_failed: 'Failed to Unarchive Product',
        lbl_failed_status: 'Failed to update status',
        lbl_deactivate: 'Deactivate',
        lbl_activate: 'Activate',
        lbl_delete: 'Delete',
        lbl_unarchive: 'Unarchive',
        lbl_archive_confirmation: 'Archive Product',
        lbl_overview_details: 'Details',
        lbl_unarchive_confirmation: 'Unarchive Product',
        lbl_activate_confirmation: 'Activate Product',
        lbl_deactivate_confirmation: 'Deactivate Product',
        msg_archive_confirmation: '<p></p><p>Are you sure you want to archive this product?</p><p><b>Are you sure you want to archive this product? This product will no longer be available for new orders but will be retained in the system.</b></p><p></p>',
        msg_unarchive_confirmation: '<p></p><p>Are you sure you want to unarchive this product?</p><p><b>Once unarchived, it will be moved back to the active products section.</b></p><p></p>',
        msg_activate_confirmation: '<p></p><p>Are you sure you want to activate this product?</p>',
        msg_deactivate_confirmation: '<p></p><p>Are you sure you want to Deactivate? Deactivating a record does not remove it from system, but it will no longer be usable.</p><p><b>Products with active work orders cannot be Deactivate. Please complete any active work orders before you proceed.</b></p>',
        message: {
          confirm_delete_msg: '<p></p><p>Are you sure you want to delete this product?</p><p><b>Once deleted, it can\'t be undone.</b></p><p></p>',
          delete_product: 'Delete Product',
          cancel: 'Cancel',
          confirm_delete_header: 'Confirm Delete Product',
        },
      },
      order_erp: {
        lbl_order_erp: 'Order ERP',
        add_order_erp: 'Add Order ERP',
        lbl_edit: 'Edit',
        lbl_activate: 'Activate',
        lbl_deactivate: 'Deactivate',
        lbl_delete: 'Delete',
        lbl_activate_successfully: 'Order ERP Status Updated Successfully',
        lbl_failed_status: 'Failed to update status',
        lbl_activate_confirmation: 'Activate Order ERP',
        lbl_deactivate_confirmation: 'Deactivate Order ERP',
        msg_activate_confirmation: '<p></p><p>Are you sure you want to activate this order ERP?</p>',
        msg_deactivate_confirmation: '<p></p><p>Are you sure you want to deactivate this order ERP?</p>',
        download_invoice: 'Download',
        no_orders_selected: 'No order ERP records selected',
        download_invoice_successful: 'Download successful',
        download_invoice_failed: 'Download failed',
        invalid_response: 'Invalid response',
        message: {
          confirm_delete_msg: '<p></p><p>Are you sure you want to delete this order ERP?</p><p><b>Once deleted, it can\'t be undone.</b></p><p></p>',
          confirm_delete_header: 'Confirm Delete Order ERP',
        },
      },
      site: {
        lbl_sites: 'Sites',
        lbl_site: 'Sites',
        add_site: 'Add Site',
        lbl_save_site: 'Save Site',
        lbl_update_site: 'Update Site',
        lbl_add_delivery_address: 'Add Delivery Address',
        lbl_update_delivery_address: 'Update Delivery Address',
        lbl_overview: 'Overview',
        lbl_delivery: 'Delivery',
        lbl_edit: 'Edit',
        lbl_deactivate: 'Deactivate',
        lbl_activate: 'Activate',
        lbl_delete: 'Delete',
        lbl_delivery_details: 'Delivery Details',
        lbl_active_protocols: 'Active Protocols',
        lbl_users: 'Users',
        lbl_delivery_address: 'Delivery Address',
        lbl_default_address: 'Primary Delivery Address',
        lbl_address_name: 'Name',
        lbl_mark_as_primary: 'Mark as Primary',
        lbl_site_address: 'Site Address',
        lbl_delivery_days: 'Delivery Schedule',
        lbl_site_added_successfully: 'Site Added Successfully',
        lbl_site_updated_successfully: 'Site Status Updated Successfully',
        lbl_site_deactivated_successfully: 'Site Deactivated Successfully',
        lbl_site_activated_successfully: 'Site Activated Successfully',
        lbl_activate_successfully: 'Site Status Updated Successfully',
        confirm_deactivate_header: 'Confirm Deactivate Site',
        confirm_activate_header: 'Confirm Activate Site',
        lbl_activate_confirmation: 'Activate Site',
        lbl_active_users: 'Active Users',
        lbl_protocols: 'Protocols',
        lbl_status: 'Status',
        lbl_role: 'Role',
        lbl_first_name: 'First Name',
        lbl_last_name: 'Last Name',
        lbl_email: 'Email',
        btn_add_protocol: 'Add Protocol',
        btn_add_user: 'Add User',
        btn_add_first_protocol: 'Add Your First Protocol',
        btn_add_first_user: 'Add Your First User',
        msg_no_protocols_found: 'No protocols found for this site',
        msg_no_users_found: 'No users found for this site',
        lbl_protocol_name: 'Protocol Name/Number',
        lbl_protocol_code: 'Protocol Code',
        lbl_start_date: 'Start Date',
        lbl_end_date: 'End Date',
        lbl_add_protocol: 'Add Protocol',
        msg_add_protocol_placeholder: 'Protocol Management',
        msg_add_protocol_description: 'Protocol assignment functionality will be implemented here',
        lbl_deactivate_confirmation: 'Deactivate Site',
        msg_activate_confirmation: '<p></p><p>Are you sure you want to activate this site?</p>',
        msg_deactivate_confirmation: '<p></p><p>Are you sure you want to deactivate this site?</p>',

        message: {
          confirm_delete_msg: '<p></p><p>Are you sure you want to delete this site?</p><p><b>Once deleted, it can\'t be undone.</b></p><p></p>',
          delete_site: 'Delete Site',
          cancel: 'Cancel',
          confirm_delete_header: 'Confirm Delete Site',
        },
      },

      site_delivery_address: {
        lbl_mark_as_primary: 'Mark as Primary',
        lbl_activate: 'Activate',
        lbl_deactivate: 'Deactivate',
        lbl_activate_confirmation: 'Activate Site Delivery Address',
        lbl_deactivate_confirmation: 'Deactivate Site Delivery Address',
        msg_activate_confirmation: '<p></p><p>Are you sure you want to activate this site delivery address?</p>',
        msg_deactivate_confirmation: '<p></p><p>Are you sure you want to deactivate this site delivery address?</p>',
        lbl_activate_successfully: 'Site Delivery Address Activated Successfully',
        lbl_deactivate_successfully: 'Site Delivery Address Deactivated Successfully',
        lbl_failed_status: 'Failed to update status',
        lbl_mark_as_primary_confirmation: 'Mark as Primary',
        msg_mark_as_primary_confirmation: '<p></p><p>Are you sure you want to mark this site delivery address as primary?</p>',
        lbl_add_delivery_address: ' Delivery Address Added Successfully',
        lbl_update_delivery_address: 'Delivery Address Updated Successfully',
        lbl_assigned_primary_successfully: 'This Address Assigned As Primary Delivery Address Successfully ',
      },
      protocol: {
        lbl_add_purchase_order: 'Add Purchase Order',
        lbl_add_product: 'Add Protocol Product',
        lbl_update_product: 'Update Protocol Product',
        lbl_edit_product: 'Edit Protocol Product',
        lbl_edit_purchase: 'Edit Purchase Order',
        lbl_add_purchase: 'Add Purchase Order',
        add_protocol: 'Add Protocol',
        lbl_add_protocol: 'Add Protocol',
        lbl_products_details: 'Products ',
        lbl_purchase_details: 'Purchase Orders ',
        lbl_protocol: 'Protocols',
        lbl_details: 'Details',
        lbl_activate: 'Activate',
        lbl_deactivate: 'Deactivate',
        lbl_edit_protocol: 'Edit Protocol',
        lbl_add_new_protocol: 'Add New Protocol',
        lbl_update_protocol: 'Update Protocol',
        lbl_save_protocol: 'Save Protocol',
        lbl_protocol_added_successfully: 'Protocol Added Successfully',
        lbl_protocol_updated_successfully: 'Protocol Updated Successfully',
        lbl_review_protocol: 'Review Protocol',
        lbl_bulk_update_protocol: 'Bulk Update Protocol',
        lbl_print_label: 'Print Label',
        lbl_all: 'All',
        lbl_draft: 'Draft',
        lbl_completed: 'Completed',
        lbl_inactive: 'Inactive',
        lbl_running: 'Active',
        lbl_patients: 'Patients',
        message: {
          confirm_delete_msg: '<p></p><p>Are you sure you want to delete this protocol?</p><p><b>Once deleted, it can\'t be undone.</b></p><p></p>',
          delete_protocol: 'Delete Protocol',
          cancel: 'Cancel',
          confirm_delete_header: 'Confirm Delete Protocol',
        },
        lbl_overview: 'Overview',
        lbl_products: 'Products',
        lbl_product: 'Product',
        lbl_purchase_orders: 'Purchase Orders',
        lbl_orders: 'Orders',
        lbl_sites: 'Sites',
        lbl_sponsors: 'Sponsors',
        lbl_sponsor: 'Sponsor',
        lbl_activity_feed: 'Activity Feed',
        lbl_protocol_users: 'Protocol Users',
        lbl_protocol_details: 'Protocol Details',
        lbl_edit: 'Edit',
        lbl_delete: 'Delete',
        lbl_archive: 'Archive',
        lbl_activate_protocol: 'Activate Protocol',
        lbl_deactivate_protocol: 'Deactivate Protocol',
        lbl_complete_protocol: 'Complete Protocol',
        lbl_activate_confirmation: 'Activate Protocol',
        lbl_deactivate_confirmation: 'Deactivate Protocol',
        lbl_complete_confirmation: 'Complete Protocol',
        lbl_activate_successfully: 'Protocol Activated Successfully',
        lbl_deactivate_successfully: 'Protocol Deactivated Successfully',
        lbl_complete_successfully: 'Protocol Completed Successfully',
        lbl_add_gps_telematics_integration: 'Add GPS Telematics Integration',
        msg_activate_confirmation: '<p></p><p>Are you sure you want to activate this protocol?</p></p>',
        msg_deactivate_confirmation: '<p></p><p>Are you sure you want to deactivate this protocol?</p>',
        msg_complete_confirmation: '<p></p><p>Are you sure you want to complete this protocol?</p>',
        msg_archive_confirmation: '<p></p><p>Are you sure you want to archive this protocol?</p><p><b>Once archived, it will be moved to the archived section.</b></p><p></p>',
        msg_unarchive_confirmation: '<p></p><p>Are you sure you want to unarchive this protocol?</p><p><b>Once unarchived, it will be moved back to the active protocols section.</b></p><p></p>',
        lbl_date_time: 'Date & Time',
        lbl_updated_by: 'Updated By',
        lbl_add_protocol_user: 'Add Protocol User',
        lbl_update_protocol_user: 'Update Protocol User',
        lbl_add_site: 'Add Site',
        lbl_update_site: 'Update Site',
        lbl_status_updated_successfully: 'Protocol Status Updated Successfully',
        lbl_update_purchase_order: 'Update Purchase Order',
        lbl_edit_protocol_site: 'Edit Protocol Site',
        lbl_add_protocol_site: 'Add Protocol Site',
        lbl_update_protocol_site: 'Update Protocol Site',
      },
      change_review: {
        lbl_change_reviews: 'Protocol Change Reviews',
        lbl_details: 'Details',
        lbl_view_change: 'View Change',
        lbl_overview_details: 'Details',
        lbl_list_id: 'ID',
        lbl_protocol: 'Protocol Name/Number',
        lbl_change: 'Change',
        lbl_data: 'Data',
        lbl_action_reason: 'Approve/Reject Reason',
        lbl_protocol_reason: 'Action Reason',
        lbl_status: 'Status',
        lbl_created_by: 'Created By',
        lbl_model: 'Model',
        lbl_action: 'Action',
        lbl_created_at: 'Created At',
        lbl_status_update_msg: 'Protocol Status Updated Successfully.',
        lbl_enter_reason: 'Enter Reason',
        lbl_error_message: 'Reason is required',
        lbl_change_reason_max: 'Reason must not exceed 500 characters.',
        lbl_change_reason_max_hint: 'Max 500 characters allowed',
      },

      audit_logs: {
        lbl_id: 'ID',
        lbl_first_name: 'First Name',
        lbl_last_name: 'Last Name',
        lbl_entity_type: 'Entity Type',
        lbl_event_type: 'Event Type',
        lbl_event_status: 'Event Status',
        lbl_created_at: 'Created At',
        lbl_event_reason: 'Event Reason',
        lbl_export: 'Export Audit Logs',
        lbl_audit_log: 'Audit Logs',
        lbl_protocol: 'Protocol Name/Number',
        lbl_startDate: 'From Date',
        lbl_end_date: 'To date',
        error_invalid_date_range_summary: 'Invalid Date Range',
        error_date_range_max_31_days: 'Date range cannot exceed 31 days',
        warning_incomplete_date_range_summary: 'Incomplete Date Range',
        warning_both_dates_required: 'Both start and end dates are required',
      },

      invoices: {
        lbl_header: 'Invoices',
        lbl_id: 'Order ID',
        lbl_protocol_name: 'Protocol Name/Number',
        lbl_date: 'Date',
        lbl_invoice: 'Invoice Number'
      },

      reports: {
        lbl_trial_report: 'Order Report',
        lbl_myob_report: 'MYOB Report',
        lbl_myob_order_report: 'MYOB Order Report',
        lbl_aksys_order_report: 'Order Report',
        lbl_trial_name: 'Trial name',
        lbl_sponsor: 'Sponsor',
        lbl_start_date: 'Start Date',
        lbl_end_date: 'End Date',
        lbl_total_sites: 'Total Sites',
        lbl_active_sites: 'Active Sites',
        lbl_trial_status: 'Trial Status',
        lbl_protocol: 'Protocol',
        lbl_site: 'Site',
        lbl_order_creation_date: 'Order Creation Date',
        lbl_order_received_date: 'Order Received Date',
        select_protocol: 'Select Protocol',
        select_site: 'Select Site',
        select_date_range: 'Select Date Range',
        download_report: 'Download Report',
        downloading: 'Downloading...',
        select_at_least_one_filter: 'Please select at least one filter to generate the report',
        date_range_max_31_days: 'Date range cannot exceed 31 days',
        date_range_validation_error: 'Please correct the date range errors before proceeding',
        report_downloaded_successfully: 'Report downloaded successfully',
        download_failed: 'No data found for export.',
        invalid_response: 'Invalid response from server',
        order_summary_reports: {
          lbl_order_report: 'Order Summary Report',
          lbl_total_orders: 'Total Orders',
          lbl_confirmed: 'Confirmed',
          lbl_rejected: 'Rejected',
          lbl_fulfilled: 'Fulfilled',
          lbl_site: 'Site/Trial',
        }
      },

      events: {
        can_not_change_status_of_ongoing_event: 'Can not change status of ongoing event.',
        only_300_chars_allowed: 'Only 300 Chars are allowed.',
        description_placeholder: '300 chars are allowed',
        date_format_info: 'Choose how times are displayed in certain parts of the application (affects all users for an account.)',
        character_limit_500: 'Character limit 300',
        please_enter_value: 'Please enter value',
        lbl_yes: 'Yes',
        lbl_no: 'No',
        event_change_confirmation_msg: 'Changing event will reload the admin portal, Are you sure you want to continue?',
        confirmation_msg: 'Creating or Modifying event will reload the admin portal, Are you sure you want to continue?',
        confirmation: 'Confirmation',
        configuration_settings: 'Configuration Settings',
        event_configuration: 'Event Configuration',
        select_short_date_format: 'Select Short Date Format',
        select_time_format: 'Select Time Format',
        short_date_is_required: 'Short Date is Required.',
        please_add_event_to_add_time_settings: 'Please Add event details to add time and regional settings',
        status: 'Date',
        sidebar_lbl_events: 'Events',
        lbl_state: 'State',
        add_event: 'Add Event',
        add_employees: 'Add Employee',
        edit_event: 'Edit Event',
        lbl_update_events: 'Update Event',
        lbl_edit: 'Edit',
        update_events: 'Update Events',
        delete: "Delete",
        event_added_successfully: 'Event Added Successfully.',
        event_updated_successfully: 'Event Details Updated Successfully.',
        lbl_details: 'Details',
        event_related_settings: 'Related Settings',
        lbl_address: 'Address',
        lbl_save: 'Save',
        lbl_cancel: 'Cancel',
        lbl_event_deleted_successfully: 'Event Deleted Successfully.',
        lbl_review_events: 'Review Events',
        lbl_add_new_events: 'Add New Event',
        lbl_make_event_inactive: 'Make Event Inactive',
        lbl_make_event_active: 'Make Event Active',
        lbl_make_event_inactive_msg: 'Creating or Modifying event will reload the admin portal, Are you sure you want to make event inactive?',
        lbl_make_event_active_msg: 'Creating or Modifying event will reload the admin portal, Are you sure you want to make event active?',
        lbl_event_status_updated_successfully: 'Event status updated successfully.',
        lbl_regional_settings: 'Regional Settings',
        short_date_format: 'Short Date Format',
        time_zone: 'Time Zone',
        time_format: 'Time Format',
        time_settings: 'Time Settings',
        message: {
          confirm_delete_msg: '<p></p><p>Are you sure you want to delete this events?</p><p><b>Once deleted, it can\'t be undone.</b></p><p></p>',
          delete_vehicle: 'Delete Event',
          cancel: 'Cancel',
          confirm_delete_header: 'Confirm Delete Event',
        },
        columns: {
          name: 'Event',
          code: 'Short Code',
          start_date: 'Start Date',
          end_date: 'End Date',
          state: 'State',
          status: 'Status'
        },
        lbl_select_an_event: 'Select an Event',
        lbl_name: 'Name',
        lbl_enter_event_name: 'Enter Event Name',
        name_is_required: 'Name is required.',
        lbl_short_code: 'Short Code',
        lbl_enter_event_short_code: 'Enter event Short Code',
        short_code_is_required: 'Short Code is required.',
        lbl_transport_supervisor_number: 'Transport Supervisor Number',
        lbl_enter_transport_supervisor_number: 'Enter Transport Supervisor Number.',
        transport_supervisor_contact_number_is_required: 'Transport Supervisor Number is required.',
        lbl_emergency_number: 'Emergency Number',
        lbl_emergency_contact_number: 'Emergency Contact Number',
        emergency_contact_number_is_required: 'Emergency Number is required.',
        lbl_enter_emergency_number: 'Enter Emergency Number.',
        description: 'Description',
        map_address: 'Map Address',
        map_address_is_required: 'Map Address is required.',
        event_logo: 'Event Logo',
        image: 'Image',
        lbl_this_image_will_appear_in_event_list: 'This image will appear in event list',
        lbl_this_address_will_be_used_to_determine_the_timezone_for_this_event: 'This address will be used to determine the timezone for this event.',
        lbl_related_settings: 'Related Settings',
        transportation_type: 'Transportation Type',
        transportation_type_is_required: 'Transportation Type is required.',
        select_transportation_type: 'Select Transportation Type',
        start_date_is_required: 'Start Date is required',
        transportation_start_date: 'Start Date (Transportation Start Date)',
        transportation_end_date: 'End Date (Transportation End Date)',
        end_date_is_required: 'End Date is required.',
        start_booking_date_passenger_app: 'Start Booking Date (Passenger App)',
        stop_booking_date_passenger_app: 'Stop Booking Date (Passenger App)',
        start_booking_date_is_required: 'Start Booking Date is required.',
        end_booking_date_is_required: 'Stop Booking Date is required.',
        operating_radius: 'Operating Radius',
        broadcast_radius: 'Broadcast Radius',
        select_operating_radius: 'Select Operating Radius',
        enter_broadcast_radius: 'Enter Broadcast Radius',
        operating_radius_is_required: 'Operating Radius is required',
        select_transportation_start_date: 'Select Transportation Start Date',
        select_transportation_end_date: 'Select Transportation End Date',
        select_start_booking_date: 'Select Start Booking Date',
        select_stop_booking_date: 'Select Stop Booking Date',
        lbl_the_maximum_distance_the_services_can_be_provided_or_operate_effectively: 'Define the operating radius (in km/miles) within which transport services will be available. Dispatch zone can be created within this distance from the event location or map address.',
        lbl_the_radius_will_be_used_for_serving_the_drivers_for_booking_at_the_time_of_auto_broadcast: 'Set the radius (in km/miles) within which trip requests will be automatically broadcasted to available drivers. Only drivers within this range from the pickup location will receive the request.',
        please_enter_valid_event_name: 'Please enter alphanumeric characters or alphabets only.',
        please_enter_valid_short_code: 'Please enter valid short code.',
        description_is_required: 'Description is required.',
        time_and_regional_settings: 'Time & Regional Settings',
        lbl_regional_settings_saved_successfully: 'Regional Settings saved successfully.'
      },
      protocol_product: {
        lbl_activate_successfully: 'Protocol Product Activated Successfully',
        lbl_deactivate_successfully: 'Protocol Product Deactivated Successfully',
        lbl_activate_confirmation: 'Activate Protocol Product',
        msg_activate_confirmation: 'Are you sure you want to activate this protocol product?',
        lbl_deactivate_confirmation: 'Deactivate Protocol Product',
        msg_deactivate_confirmation: 'Are you sure you want to deactivate this protocol product?',
        lbl_status_updated_successfully: 'Protocol Product Status Updated Successfully',
      },

      purchase_order: {
        lbl_edit: 'Edit',
        lbl_activate: 'Activate',
        lbl_deactivate: 'Deactivate',
        lbl_purchase_order: 'Purchase Order',
        lbl_purchase_orders: 'Purchase Orders',
        lbl_purchase_order_details: 'Purchase Order Details',
        lbl_purchase_order_status: 'Purchase Order Status',
        lbl_purchase_order_status_details: 'Purchase Order Status Details',
        lbl_purchase_order_added_successfully: 'Purchase Order Added Successfully',
        lbl_purchase_order_updated_successfully: 'Purchase Order Updated Successfully',
        lbl_status_updated_successfully: 'Purchase Order Status Updated Successfully',
        msg_activate_confirmation: 'Are you sure you want to activate this purchase order?',
        msg_deactivate_confirmation: 'Are you sure you want to deactivate this purchase order?',
        lbl_activate_confirmation: 'Activate Purchase Order',
        lbl_deactivate_confirmation: 'Deactivate Purchase Order',
      },

      prtocol_site: {
        lbl_activate_confirmation: 'Activate Protocol Site',
        msg_activate_confirmation: 'Are you sure you want to activate this protocol site?',
        lbl_deactivate_confirmation: 'Deactivate Protocol Site',
        msg_deactivate_confirmation: 'Are you sure you want to deactivate this protocol site?',
        lbl_status_updated_successfully: 'Protocol Site Status Updated Successfully',
      },
      protocol_user: {
        lbl_protocol_user: 'Protocol User',
        lbl_protocol_users: 'Protocol Users',
        lbl_protocol_user_details: 'Protocol User Details',
        lbl_protocol_user_status: 'Protocol User Status',
        lbl_protocol_user_status_details: 'Protocol User Status Details',
        lbl_protocol_user_added: 'Protocol user created successfully',
        lbl_protocol_user_updated: 'Protocol user updated successfully',
        msg_activate_confirmation: 'Are you sure you want to activate this protocol user?',
        msg_deactivate_confirmation: 'Are you sure you want to deactivate this protocol user?',
        lbl_activate_confirmation: 'Activate Protocol User',
        lbl_failed_status: 'Failed to update status',
        lbl_activate_successfully: 'Protocol user status updated successfully',
        confirm_delete_header: 'Confirm Delete Protocol User',
        lbl_deactivate_confirmation: 'Deactivate Protocol User',
        confirm_delete_msg: '<p></p><p>Are you sure you want to delete this protocol user?</p><p><b>Once deleted, it can\'t be undone.</b></p><p></p>',
      },

      order: {
        lbl_new_order: 'New Order',
        add_order: 'Add Order',
        lbl_order: 'Order',
        lbl_orders: 'Orders',
        lbl_update_order: 'Update Order',
        lb_save_order: 'Save Order',
        lbl_edit_order: 'Edit Order',
        lbl_order_details: 'Order Details',
        lbl_order_status: 'Order Status',
        lbl_order_status_details: 'Order Status Details',
        lbl_order_status_updated_successfully: 'Order Status Updated Successfully',
        lbl_all: 'All',
        lbl_active: 'Active',
        lbl_to_be_invoiced: 'To Be Invoiced',
        lbl_completed: 'Completed',
        lbl_rejected: 'Cancelled',
        lbl_archive: 'Archive',
        lbl_unarchive: 'Unarchive',
        lbl_delete: 'Delete',
        lbl_edit: 'Edit',
        lbl_add_order: 'Add Order',
        lbl_update_orders: 'Update Orders',
        lbl_review_orders: 'Review Orders',
        lbl_qty: 'Quantity',
        lbl_select_patient: 'SELECT PATIENT(S)',
        lbl_product: 'PRODUCT',
        lbl_order_added_successfully: 'Order placed successfully',
        lbl_details: 'Details',
        lbl_protocol: 'PROTOCOL',
        lbl_search: 'Search',
        lbl_no_products_found: 'No products available for this protocol',
        lbl_please_select_protocol: 'Please select a protocol to continue',
        lbl_confirm_order: 'Order Confirmed Successfully',
        lbl_reject_order: 'Order Cancelled Successfully',
        lbl_partial_order_confirmed: 'Partial Order Placed Successfully',
        lbl_partial_order: 'Partial Order Confirmed Successfully',
        entity_created_at: 'Date',
        created_by: 'Created By Role',
        expected_dispatch_date: 'Expected Dispatch Date',
        lbl_order_submitted: 'Order Submitted',
        lbl_order_delivered: 'Order Delivered',
        lbl_order_confirmed_date: 'Order Confirmation Date',
        lbl_place_order: 'Place Order',
        lbl_selected: 'Selected',
        lbl_please_add_qty: 'Please add quantity for at least one product',
        lbl_status_and_updates: 'Status & Updates',
        lbl_total_order: 'Total Order',
        lbl_sub_total: 'Sub Total',
        lbl_delivery_date: 'Delivery Date',
        lbl_gst: 'GST',
        lbl_total_units: 'Total Units',
        lbl_dispatch_date_of_product_in_stock: 'Dispatch Date Of Product In Stock',
        lbl_product_in_stock: 'Product In Stock',
        lbl_dispatch_date_of_remaining_products: 'Dispatch Date Of Remaining Products',
        lbl_remaining_products: 'Remaining Products',
        lbl_required_qty: 'Required Quantity',
        lbl_order_confirmation: 'Order Confirmation',
        lbl_return_order_confirmation: 'Returned Order Details',
        lbl_confirm_product_s: 'Confirm Product(s)',
        lbl_qty_received: 'Quantity Received',
        lbl_batch: 'Batch',
        lbl_expiry: 'Expiry',
        lbl_initiate_the_return: 'Click "Return" to initiate the return of this product',
        lbl_return: 'Return',
        lbl_return_product_s: 'Return Product(s)',
        lbl_qty_to_return: 'Quantity To Return',
        lbl_qty_returned: 'Quantity Returned',
        lbl_rejection_reason: 'Rejection Reason',
        lbl_total_unit: 'Total Unit',
        lbl_confirm_order_received: 'Confirm Order Received',
        lbl_confirm_order_received_initiate_return: 'Confirm Order Received & Initiate Return',
        msg_confirm_order_received: 'Are you sure you want to confirm that you\'ve received this order?',
        msg_confirm_order_received_return: 'Are you sure you want to confirm order received & initiate return?',
        error_batch: 'Batch is required',
        error_batch_max_length: 'Batch number must not exceed 20 characters',
        error_expiry_date: 'Expiry date is required',
        error_received_quantity: 'Quantity is invalid',
        error_quantity_invalid: 'Quantity is invalid',
        error_qty_returned_greater_than_zero: 'Quantity Returned should be greater than 0.',
        msg_order_confirmed_successfully: 'Order Received Successfully',
        msg_order_return_confirmed_successfully: 'Order received confirmed and return initiated successfully',
        lbl_out_of: 'Out of ',
        lbl_have_confirmed_and: ' of your products have been confirmed, and ',
        lbl_processed_for_return: ' are being processed for return. Kindly provide a reason for return.',
        error_received_quantity_count: 'Count of product should be valid',
        label_confirm_order: 'Confirm Order',
        lbl_upload_proof_of_return: 'Upload Proof Of Return',
        ph_upload_proof_of_return: 'Upload Proof Of Return is required.',
        lbl_reason_for_return: 'Reason For Return',
        lbl_enter_reason: 'Enter Reason',
        lbl_reason_for_return_required: 'Reason For Return is required.',
        lbl_reason_for_return_max: 'Reason must not exceed 500 characters.',
        lbl_reason_for_return_min: 'Reason must be at least 2 characters.',
        lbl_reason_for_rejection_max: 'Reason must not exceed 500 characters.',
        lbl_reason_for_rejection_max_hint: 'Max 500 characters allowed',
        lbl_order_summary: 'Order Summary',
        lbl_price: 'Price',
        lbl_unit_cost: 'Unit Cost',
        lbl_unit_cost_required: 'Unit cost is required',
        lbl_total: 'Total',
        lbl_was_rejected_reason: 'Order Was Cancelled For The Following Reason:',
        lbl_inactive: 'Protocol Is Inactive Or Has Already Concluded.',
        lbl_order_reject: 'Order Cancelled On ',
        export: 'Download Invoice',
        mark_as_completed_and_download_invoice: 'Mark As Completed',
        download_successful: 'Download successful',
        download_invoice_successful: 'Download Invoice(s) successful',
        mark_as_completed_and_download_invoice_successful: 'Order(s) Marked As Completed',
        download_failed: 'Download failed',
        download_invoice_failed: 'Download Invoice(s) failed',
        invalid_response: 'Invalid response',
        no_orders_selected: 'No orders selected',
        error_confirmed_returned_quantity_issue: 'Confirmed & Returned quantity should be equal to Requested quantity.',
        error_required_confirm_batch_expiry: 'Missing Batch or Expiry date for products. Please fill all the details.',
        download_invoice: 'Download Invoice',
        qty_ordered: 'Quantity Ordered',
        ordered_by: 'Ordered By',
        linked_site: 'Linked Sites',
        lbl_click_return_to_edit: 'Click "Return" to edit the quantity.',
        lbl_rejection_reason_type: 'Rejection Reason Type',
        lbl_select_rejection_reason_type: 'Select Rejection Reason Type',
        lbl_rejection_reason_type_required: 'Rejection Reason Type is required.',
        lbl_selected_patient: 'SELECTED PATIENT(S)',
        lbl_view_patient: 'View Patient(s)',
        lbl_patients: 'Patients',
        lbl_confirm_order_header: 'Do you really want to proceed with this order?',
        lbl_patient_info: 'Patient Info',
        lbl_add_new_batch: 'Add New Batch',
        lbl_max_batches_reached: 'Maximum number of batches reached for this product.',
        lbl_full_order_confirmation: 'Full Order Confirmation',
        lbl_partial_order_confirmation: 'Partial Order Confirmation',
        lbl_red_tick: 'Red Tick',
        lbl_return_summary: 'Returned Order Summary',
        error_rejection_reason_type: 'Rejection Reason Type is required.',
        error_reason_for_rejection: 'Reason For Rejection is required.',
        lbl_split_order: 'Split Order',
        lbl_dispatch_date: 'Dispatch Date',
        lbl_remove_split_order: 'Remove Split Order',
      },

      lbl_return_order: 'Return Order',
      lbl_add_new_features: 'Add new features',
      lbl_add_document: 'Add Document',
      lbl_next: 'Next',
      lbl_previous: 'Previous',
      lbl_add_new_vehicles: 'Add New Vehicle',
      lbl_edit_vehicles: 'Edit Vehicle',
      lbl_save_vehicle: 'Save Vehicle',
      lbl_update_vehicle: 'Update Vehicle',
      lbl_select_all: 'Select All',
      lbl_select_all_count: 'Select All',
      lbl_select_field: '{{field}}',
      lbl_print_labels: 'Print Labels',
      print_label_sub_header: 'This will generate a printable PDF template of labels for the ',
      print_label_sub_header2: 'selected vehicles.',
      lbl_select_label_quantity: '1. Select label quantity',
      lbl_select_label_size: '2. Select label size',
      lbl_small_size: 'Small (1" x 2-5/8")',
      lbl_large_size: 'Large (2" x 4")',
      lbl_avery_30_per_sheet: 'Avery 5160/8160, 30 per sheet',
      lbl_avery_10_per_sheet: 'Avery 5163/8163, 10 per sheet',
      lbl_small_labels_we_recommend: 'For small labels we recommend:',
      lbl_large_labels_we_recommend: 'For large labels we recommend:',
      lbl_avery_inkjet: 'Avery 8160 (Inkjet) -',
      lbl_avery_laser: 'Avery 5160 (Laser) -',
      lbl_inches_1: '1 x 2.62 inches',
      lbl_inches_2: '2 x 4 inches',
      lbl_template_preview: 'Template Preview',
      lbl_label_preview: 'Label Preview',
      lbl_generate_template: 'Generate Template',
      lbl_print_label_tooltip_msg: 'Use this amount to control the number of label duplicates you want to create for each vehicle',
      lbl_qr_code: 'QR Code',
      lbl_vehicle_name: 'Vehicle Name',
      lbl_add_new_feature: 'Add New Features',
      lbl_enter_here: 'Enter here',
      lbl_note: 'Note: ',
      lbl_edit_or_delete_new_feature: 'For edit or delete new feature please go to ',
      lbl_settings_vehicle_features: 'Settings > Vehicle > features',
      lbl_default_vehicle: 'Default Vehicle',
      lbl_slot: 'Slot',
      lbl_remove: 'Remove',
      lbl_record: 'Record',
      lbl_save_driver: 'Save Driver',
      lbl_update_driver: 'Update Driver',
      lbl_add_new_driver: 'Add New Drivers',
      lbl_download_label: 'Download Label',
      lbl_print_label: 'Print Label',
      lbl_edit: 'Edit',
      lbl_address_information: 'ADDRESS INFORMATION',
      lbl_other_details: 'OTHER DETAILS',
      lbl_geo_location: 'GEO LOCATION',
      lbl_busy_on_the_way: 'Busy - On the way',
      lbl_background_check: 'Background Check',
      lbl_availability_preference: 'Availability Preference',
      lbl_driving_records: 'Driving Records',
      manage_group: {
        lbl_new_groups: 'Add Group',
        lbl_save_group: 'Save Group',
        lbl_groups: 'Groups',
        lbl_cancel: 'Cancel',
        lbl_update_group: 'Update',
        lbl_address: 'Address',
        update_group: 'Update Shift Groups',
        import_group: 'Import Groups',
        add: 'Add',
        edit: 'Edit',
        lbl_add_group: 'Add Group',
        lbl_edit_group: 'Edit Group',
        lbl_save_and_add_another: 'Save & Add Another',
        lbl_update_and_add_another: 'Update & Add Another',
        group_added_successfully: 'Group Added Successfully',
        active_group_message: 'Are you sure you want to make group active?',
        inactive_group_message: 'Are you sure you want to make group inactive?',
        active_group_header_message: 'Make Group Active',
        inactive_group_header_message: 'Make Group Inactive',
        group_added: 'Group Added',
        delete: 'Delete Group',
        lbl_make_group_active: 'Make Group Active',
        lbl_make_group_inactive: 'Make Group Inactive',
        lbl_group_details: 'Groups Details',
        lbl_search_driver_group: 'Search Driver Group',
        lbl_confirmation: 'Confirmation',
        confirmation_msg: 'Are you sure you want to apply these changes?',
        message: {
          confirm_delete_msg: '<p></p><p>Are you sure you want to delete this Group?</p><p><b>Once delete, it can\'t be undone. The Group needs to be added again.</b></p><p></p>',
          delete_vehicle: 'Delete Group',
          cancel: 'Cancel',
          confirm_delete_header: 'Confirm Delete Groups',
          group_delete_success: 'Group Deleted Successfully',
        },
        lbl_save: 'Save',
        lbl_update: 'Update',
        added_drivers: 'Added Drivers',
        bulk_update_header: 'Update Shift Groups',
        lbl_group: 'Group',
        review_header: 'Review Shift Groups',
        updateBtnLbl: 'Shift Group'
      },
      lbl_edit_driver: 'Edit Driver',
      lbl_cancel: 'Cancel',
      lbl_address: 'Address',
      lbl_drivers_deleted_successfully: 'Drivers deleted successfully',
      lbl_assign_vehicle: 'Assign Vehicle',
      lbl_assign_driver_group_success: 'Driver group assigned successfully',
      lbl_assign_checkin_location_success: 'Check-in location assigned successfully',
      lbl_release_checkin_location_success: 'Check-in location released successfully',
      lbl_assign_vehicle_success: 'Vehicle assigned successfully',
      lbl_modify_vehicle_assign_success: 'Default vehicle assigned successfully',
      lbl_release_driver_group_success: 'Driver group released successfully',
      lbl_release_modify_vehicle_success: 'Vehicle released successfully',
      lbl_off_duty_reason_success: 'Off duty reason assigned successfully',
      lbl_invalid_data: 'Invalid data',
      lbl_home: 'Home',
      lbl_new_leave: 'New Leave',
      lbl_leaves_overview: 'LEAVES OVERVIEW',
      lbl_today: 'TODAY',
      lbl_tomorrow: 'TOMORROW',
      lbl_view_all: 'View All',
      lbl_apply_leave: 'Apply Leave',
      lbl_edit_leave: 'Edit Leave',
      lbl_driver_name_id: 'Driver Name/ID',
      lbl_search_name_id: 'Search Driver By Name/ID',
      lbl_leave_type: 'Leave Type',
      lbl_from_date: 'From Date',
      lbl_to_date: 'To Date',
      lbl_reason_for_leave: 'Reason For Leave',
      lbl_reason: 'Reason',
      lbl_driver_name_id_req: 'Driver Name/ID required',
      lbl_leave_type_req: 'Leave Type required',
      lbl_from_date_req: 'From Date required',
      lbl_to_date_req: 'To Date required',
      lbl_reason_for_leave_req: 'Reason For Leave required',
      lbl_groups: 'Groups',
      label_today: 'Today',
      label_tomorrow: 'Tomorrow',
      lbl_hex_code: 'Hex Code',
      lbl_contact_number: 'Contact Number',
      lbl_update: 'Update',
      lbl_change_password: 'Change Password',
      lbl_select_timezone: 'Select a Timezone',
      lbl_current_password: 'Current Password',
      ph_current_password: 'Enter Current Password',
      lbl_confirm_new_password: 'Confirm New Password',
      lbl_current_password_req: 'Current Password is required',
      lbl_new_password_req: 'New Password is required',
      lbl_confirm_new_password_req: 'Confirm New Password is required',
      lbl_enter_your_current_password_to_confirm: 'Enter your current password to confirm.',
      lbl_must_be_at_least_char_long: 'Must be at least {{minLength}} and maximum {{maxLength}} characters long, Must contain an uppercase and a lowercase letter (A, z), Must contain digits (0-9), Special characters (!, @, #, etc.)',
      lbl_password_requirements: 'Must be at least {{minLength}} characters long, Must contain an uppercase and a lowercase letter (A, z), Must contain digits (0-9), Special characters (!, @, #, etc.)',
      lbl_must_contain_an_uppercase_and_a_lowercase_letter: 'Must contain an uppercase and a lowercase letter (A, z)',
      lbl_please_match_the_password_with_new_password: 'Please match the password with new password',
      lbl_uploaded_file: 'File Uploaded: ',
      lbl_image_uploaded: 'Image Uploaded:',
      lbl_usage: 'Usage',
      lbl_casual_leave: 'Casual Leave',
      lbl_earned_leave: 'Earned Leave',
      lbl_sick_leave: 'Sick Leave',
      lbl_replace_with: 'Replace With',
      lbl_remove_all_values: 'Remove all values',
      lbl_working: 'Working',
      lbl_on_leave: 'On Leave',
      lbl_remove_slot_message: 'Are you sure you want to remove this slot? Removing a slot does not remove it from system, but it will no longer be usable.',
      lbl_remove_slot_header: 'Remove Slot',
      lbl_mobile_number_max_length: 'Please enter valid contact number',
      lbl_transportation_end_date: 'Transportation End Date',
      lbl_watchlist: 'Watchlist',
      lbl_type: 'Type',
      lbl_mi: 'mi',
      lbl_start_and_end_time: 'Start & End Time',
      lbl_ddr_record: 'Record',
      lbl_ddr_date: 'Date',
      lbl_ddr_note: 'Note',
      lbl_vehicle_type: 'Vehicle Type',
      lbl_languages_spoken: 'Languages Spoken',
      lbl_types_of_vehicles_driven: 'Types Of Vehicle Driven',
      lbl_search_by_driver_name_id: 'Search by Driver name / ID',
      lbl_no_usage: 'No Usage',
      lbl_driving_record: 'DRIVING RECORD',
      lbl_add_address: 'Add Address',
      lbl_save_new_address: 'Save New Address',
      lbl_locations: 'Locations',
      lbl_saved_addresses: 'Saved Addresses',
      lbl_save_address: 'Save Address',
      lbl_numbers: 'Numbers',
      lbl_alphabets: 'Alphabets',
      lbl_special_characters: 'Special Characters',
      lbl_numbers_alphabets: 'Numbers | Alphabets',
      lbl_alphabets_special_characters: 'Alphabets | Special Characters',
      lbl_number_special_characters: 'Numbers | Special Characters',
      lbl_number_alphabet_special_characters: 'Numbers | Alphabets | Special Characters',
      lbl_pdf_files_cannot_be_uploaded: 'PDF files cannot be uploaded',
      lbl_log_off: 'Log Off',
      lbl_next_shift_location_of_driver: 'Next Shift Location Of Driver',
      lbl_next_shift_location: 'Next Shift Location:',
      lbl_change_driver_on_duty: 'Change Driver On Duty',
      lbl_remove_all_columns_err_msg: 'Minimum two columns should be selected; the selection cannot be empty',
      lbl_select_journey: 'Select Journey',
      err_please_select_reporter_type_reported_by_and_incident_complaint_date: 'Please select reporter type, reported by and incident/complaint date',
      lbl_select_location_for_pickup: 'Select Location For Pickup',
      lbl_select_location_for_drop: 'Select Location For Drop',
      lbl_show_own_stay_locations_only: 'Show own stay locations only',
      lbl_select_predefined_location_category_for_pickup: 'Select Predefined Location Category For Pickup',
      lbl_select_predefined_location_category_for_drop: 'Select Predefined Location Category For Drop',
      lbl_queue_location: 'Queue Location',
      lbl_all_drivers_upper: 'ALL DRIVERS',
      lbl_add_queue: 'Add To Queue',
      lbl_assign_trip: 'Assign Trip',
      lbl_select_queue: 'Select Queue',
      lbl_add_booking_id: 'Add Booking ID',
      lbl_select_group: 'Select Group',
      lbl_incidents: 'Incidents',
      lbl_complaints: 'Complaints',
      lbl_reset_privilege_settings_header: 'Reset To Default Privilege Settings',
      lbl_reset_privilege_settings_message: '<p></p><p>Are you sure you want to reset all passengers privilege settings to their default values?</p><p></p>',
      lbl_reset_privilege_successfully: 'Passengers Privilege Settings Reset Successfully',
      lbl_must_contain_uppercase_lowercase: 'Must contain an uppercase and a lowercase letters (A, z)',
      lbl_must_contain_digits: 'Must contain digits (0-9)',
      lbl_must_contain_special_character: 'Special characters (!, @, #, etc.)',
      lbl_every_day: 'Every Day',
      lbl_pickup_time_greater: 'Pickup Time should be greater than ',
      lbl_seat: 'Seat',
      lbl_seats: 'Seats',
      order_summary: 'Order Summary',
      lbl_in_last_seven_days: 'in the last 7 days',
      lbl_placed: 'placed',
      lbl_lodged_with_supplier: 'lodged with supplier',
      lbl_confirmed: 'confirmed',
      lbl_to_invoice: 'to invoice',
      lbl_clincor_trial: 'Clincor Trial',
      lbl_total_orders: 'Total Orders',
      lbl_total_products: 'Total Products',
      lbl_total_sites: 'Total Sites',
      lbl_active_patient: 'Active Patients',
      lbl_budget_utilized: 'PO Budget Utilized',
      lbl_overview: 'Overview',
      lbl_protocol_details: 'PROTOCOL DETAILS',
      lbl_protocol_name: 'Protocol Name/Number',
      lbl_id: 'ID',
      lbl_protocol_number: 'Protocol Number',
      lbl_trial_files: 'FILES',
      lbl_status: 'Status',
      lbl_full_order: 'Confirm Full Order',
      lbl_partial_order: 'Confirm Partial Order',
      lbl_reject_order: 'Cancel Order',
      lbl_reviewer_error_msg: 'You can\'t perform this action as you have performed this change.Please contact admin or another reviewer.',

      manage_users: {
        columns: {
          lbl_name: 'Name',
          lbl_first_name: 'First Name',
          lbl_last_name: 'Last Name',
          lbl_user_email: 'Email Address',
          lbl_user_role: 'User Role',
          lbl_user_name: 'Username',
          lbl_phone_number: 'Phone Number',
          lbl_user_status: 'User Status',
          lbl_id: 'ID',
          lbl_parent: 'Site',
          lbl_user_type: 'User Type',
          lbl_user_code: 'User Code',
        },
        form_error: {
          email_required: 'Email is required',
          email_required_err: 'Email is required',
          email_length: 'Email length should not exceed 254 characters',
          email_pattern_err: 'Please enter a valid email address',
          password_required: 'Password is required',
          password_length: 'Password length should not exceed 20 characters',
          firstname_max: 'First name should not exceed 50 characters',
          firstname_min: 'First name should not be lest than 2 characters',
          firstname_pattern_err: 'Please enter a valid first name',
          first_name_err: 'First name is required',
          lastname_max: 'Last name should not exceed 50 characters',
          lastname_min: 'Last name should not be lest than 2 characters',
          lastname_pattern_err: 'Please enter a valid last name',
          last_name_err: 'Last name is required',
          contact_required_err: 'Phone number is required',
          user_type_err: 'User type is required',
          email_max_length_err: 'Email address must not exceed 254 characters.',
          email_local_part_length_err: 'The part before the "@" symbol must not exceed 64 characters.',
          parent_name_field_error: 'Parent is required.',
        },
        user_form: {
          user_details: 'User Details',
          user_role: 'User Role',
          select_user_role: 'Please select',
          first_name: 'First Name',
          last_name: 'Last Name',
          email_address: 'Email Address',
          mobile_number: 'Phone Number',
          password: 'Password',
          username: 'Username',
          new_password: 'New Password',
          confirm_password: 'Confirm Password',
          placeholder: 'Enter here',
          first_name_placeholder: 'Enter first name',
          last_name_placeholder: 'Enter last name',
          email_placeholder: 'Enter email address',
          mobile_number_placeholder: 'Enter phone number',
          lbl_credentials: 'Credentials',
          lbl_events: 'Events',
          select_parent: 'Select Site',
        },
        lbl_route_path: "Manage Users",
        lbl_create_new: "New User",
        lbl_save_location: "Save",
        lbl_cancel: "Cancel",
        lbl_update_user: "Update User",
        lbl_bulk_update_header: "Update Users",
        lbl_entity_name_display: 'user',
        btn_bulk_update: 'Users',
        lbl_review_users: "Review Users",
        import_user_template: 'Import User Templates',
        add: "Add",
        edit: "Edit",
        cancel: 'Cancel',
        update: 'Update',
        save: 'Save',
        reInvite: 'Re-Invite',
        lbl_add_user: 'Add New User',
        lbl_edit_user: 'Edit User',
        active_status_message:
          "This action will continue your account and all associated privileges.",
        inactive_status_message:
          "This action will temporarily suspend your account and all associated privileges.",
        active_user_header_message: "Activate User",
        inactive_user_header_message: "Deactivate User",
        user_added: "User Added",
        delete: "Delete",
        lbl_make_user_active: "Active",
        lbl_make_user_inactive: "Inactive",
        lbl_role_name: 'Role Name',
        lbl_description: 'Description',
        lbl_deactivate: 'Deactivate',
        lbl_activate: 'Activate',
        lbl_route_users: 'Users',
        lbl_route_user_details: 'Users Details',
        lbl_details: 'Details',
        lbl_status: 'Status',
        lbl_name: 'Name',
        lbl_email: 'Email',
        lbl_role: 'Role',
        lbl_events: 'Events',
        lbl_contact: 'Contact Number',
        lbl_credential: 'Credentials',
        lbl_username: 'Username',
        reset_info: 'User will be required to re-login with admin generated passwords & can reset it later',
        lbl_reset_passwords: 'Reset Passwords',
        lbl_reset_password: 'Reset Password',
        lbl_default_password: 'New Password',
        reset_password_err_msg: 'Password must be at least 8 characters long and include at least one uppercase letter, one lowercase letter, one number, and one special character with no spaces',
        message: {
          confirm_delete_msg:
            "<p></p><p>Are you sure you want to delete this User?</p><p><b>Once deleted, it can't be undone. The user needs to be added again.</b></p><p></p>",
          delete_user: "Delete User",
          cancel: "Cancel",
          confirm_delete_header: "Confirm Delete Users",
          msg_user_added_successfully: 'User added successfully',
          msg_user_update_successfully: 'User updated successfully',
          msg_user_active: 'User Activated Successfully',
          msg_user_inactive: 'User deactivated Successfully',
          msg_reset_password_success: 'Reset password set successfully'
        },
        lbl_invite_user: 'Invite User',
        lbl_save_user: 'Save User',
        lbl_edit: 'Edit',
        lbl_invite_users: 'Invite Users',
      },

      settings: {
        lbl_language: 'Language',
        lbl_select_language: 'Select language',
        lbl_language_validation: 'Select the language',
        lbl_timezone: 'Time Zone',
        lbl_timezone_validation: 'Select the Time Zone',
        lbl_select_timezone: 'Select timezone',
        save_configuration_settings: 'Save Configuration Settings',
        lbl_save_configuration_settings: 'Configuration Settings saved successfully',
        lbl_configuration_settings: 'Configuration Settings',
        lbl_config_settings_saved_successfully: 'Config Settings saved successfully',
        export_account_data: 'Export Account Data',
        general_settings: 'General Settings',
        lbl_save_general_settings: 'Save',
        lbl_update_general_settings: 'Update',
        lbl_general_settings_saved_successfully: 'General Settings saved successfully.',
        lbl_general_settings_updated_successfully: 'General settings updated successfully',
        lbl_user_profile_updated_successfully: 'User Profile updated successfully',
        lbl_user_profile_saved_successfully: 'User Profile saved successfully',
        lbl_notification_settings_saved_successfully: 'Notification settings saved successfully',
        lbl_notification_settings_updated_successfully: 'Notification settings updated successfully',
        lbl_save_security_settings: 'Save Security Settings',
        lbl_security_settings_saved_successfully: 'Security settings saved successfully',
        security: 'Security',
        lbl_settings: 'Settings',
        lbl_account_settings: 'Account Settings',
        lbl_user_profile: 'User Profile',
        lbl_user_profile_tab: 'USER PROFILE',
        lbl_user_login_password: 'User Login Password',
        lbl_select_driver_app_login_option: 'Select Driver App Login Option',
        lbl_select_passenger_app_login_option: 'Select Passenger App Login Option',
        lbl_password_option: 'Password Options',
        lbl_user_login_setting: 'User Login Setting',
        lbl_driver_setting: 'Driver Settings',
        lbl_passenger_setting: 'Passenger Settings',
        lbl_default_password: 'Default password',
        lbl_login_information: 'Login Information',
        lbl_change_password: 'Change Password',
        lbl_login_settings: 'Login Settings',
        lbl_change_password_uppercase: 'CHANGE PASSWORD',
        lbl_notification_settings: 'Notification & Email',
        lbl_error_password: 'New Password and Confirm Password do not match.',
        lbl_login_and_password: 'Login & Password',
        lbl_administration: 'Administration',
        lbl_general_settings: 'General Settings',
        lbl_time_settings: 'Time Settings',
        lbl_export_account_data: 'Export Account Data',
        lbl_settings_general_management: 'General',
        lbl_notification_email_settings: 'Notification & Email',
        lbl_save: 'Save',
        lbl_general_order_settings: 'GENERAL ORDER SETTINGS',
        lbl_logout: 'Logout',
        lbl_order_general_settings: 'SETTINGS',
        lbl_order_general_settings_action: 'ACTION',
        lbl_gst: 'GST',
        lbl_enter_value: 'Enter Value',
        lbl_order_status_rename: 'Order Status Rename',
        lbl_order_management: 'Order Management',
        lbl_integrations: 'Integrations',
        lbl_security: 'Security',
        lbl_system_settings: 'System Settings',
        lbl_custom_fields: 'Custom Fields',
        lbl_labels: 'Labels',
        lbl_bookings: 'Bookings',
        lbl_transportation_type: 'Transportation Type',
        lbl_child_seats: 'Child Seats',
        lbl_luggage: 'Luggage',
        lbl_journey_preference: 'Journey Preference',
        lbl_vehicle_body_type: 'Vehicle Body Type',
        lbl_vehicle_dispatch: 'Vehicle Dispatch',
        lbl_events: 'Events',
        lbl_event_status: 'Event Status',
        lbl_event_state: 'Event State',
        lbl_transportation_mode: 'Transportation Mode',
        lbl_passengers: 'Passengers',
        lbl_passenger_type: 'Passenger Type',
        lbl_passenger_status: 'Passenger Status',
        lbl_privilege_settings: 'Privilege Settings',
        lbl_default_values: 'Default Values',
        lbl_vehicles: 'Vehicles',
        lbl_vehicle_status: 'Vehicle Status',
        lbl_vehicle_types: 'Vehicle Types',
        lbl_body_types: 'Body Types',
        lbl_features: 'Features',
        lbl_drivers: 'Drivers',
        lbl_account_status: 'Account Status',
        lbl_duty_status: 'Duty Status',
        lbl_reason_for_duty_status: 'Reason For Duty Status',
        lbl_app_login: 'App Login',
        lbl_driving_record: 'Driving Record',
        lbl_leave_type: 'Leave Type',
        lbl_location: 'Locations',
        lbl_location_status: 'Location Status',
        lbl_location_category: 'Location Category',
        lbl_dispatch_zone: 'Dispatch Zone',
        lbl_concerns: 'Concerns',
        lbl_incidents_and_complaints_status: 'Incidents & Complaints Status',
        lbl_complaints_status: 'Complaints Status',
        lbl_shift_management: 'Shift Management',
        lbl_driver_group_status: 'Driver Group Status',
        lbl_group_colors: 'Group Colors',
        lbl_reason_for_break: 'Reason For Break',
        lbl_communication: 'Communication',
        lbl_message_type: 'Message Type',
        lbl_select_time: 'Select Time',
        lbl_reports: 'Reports',
        lbl_saved_reports: 'Saved Reports',
        lbl_add_event_status: 'Add Event Status',
        lbl_edit_event_status: 'Edit Event Status',
        lbl_add_label: 'Add Label',
        lbl_add_transportation_mode: 'Add Transportation Mode',
        lbl_edit_transportation_mode: 'Edit Transportation Mode',
        lbl_please_fill_the_form: 'Please fill the form',
        lbl_name_req: 'Name is required',
        lbl_vehicle_type_req: 'Vehicle type is required',
        lbl_label_req: 'Label is required',
        lbl_reason_req: 'Reason is required',
        lbl_first_name_req: 'First Name is required',
        lbl_last_name_req: 'Last Name is required',
        lbl_email_req: 'Email is required',
        lbl_phone_number_min_length: 'Minimum length should be 7',
        lbl_phone_number_max_length: 'Maximum length should not be more than 13',
        lbl_placeholder_first_name: 'Enter first name',
        lbl_placeholder_last_name: 'Enter last name',
        lbl_placeholder_email: 'Enter email address',
        first_name_max_length: 'First Name should not be more than 50 characters',
        last_name_max_length: 'Last Name should not be more than 50 characters',
        lbl_user_name_req: 'User Name is required',
        lbl_user_name_max_length: 'Username should not be more than 50 characters',
        lbl__email_req: 'Email is required',
        lbl_website_req: 'Website is required',
        email_pattern: 'Email ID is invalid.',
        website_pattern: 'Company website is invalid.',
        password_pattern: 'Please enter valid password',
        lbl_time_zone: 'Time Zone',
        lbl_send_me_email_updates_about_tms: 'Send me email updates about TMS',
        lbl_you_can_log_in_to_tms_using_your_username_or_your_email_address: 'You can log in to TMS using your username or your email address.',
        edit: 'Edit',
        delete: 'Delete',
        lbl_time_settings_saved_successfully: 'Time Settings Saved Successfully',
        lbl_save_time_settings: 'Save Time Settings',
        lbl_mark_as_default: 'Mark as Default',
        lbl_select_color: 'Select Color',
        lbl_default: 'Default',
        lbl_profile_data_updated_successfully: 'Profile Data Updated Successfully',
        lbl_login_info_updated_successfully: 'Login Information Updated Successfully',
        faq_add_message: 'FAQ added successfully',
        faq_update_message: 'FAQ updated successfully',
        faq_delete_message: 'FAQ deleted successfully',
        error_faq_delete_message: 'Error while deleting FAQ',
        error_faq_update_message: 'Error while updating FAQ',
        error_faq_add_message: 'Error while adding FAQ',
        terms_and_cond_update_msg: 'Terms and Conditions Updated Successfully',
        privacy_policy_update_msg: 'Privacy Policy Updated Successfully',
        contact_support_update_msg: 'Contact support Updated Successfully',
        contact_support_added_msg: 'Contact support added Successfully',
        about_us_information_update_msg: 'About Us Information Updated Successfully',
        require_validation_checkbox: 'Require At least One is required',
        lbl_error_message_new_password: 'New password cannot exceed 20 characters.',
        lbl_error_message_confirm_password: 'Confirm password cannot exceed 20 characters.',
        booking: {
          lbl_bookings: 'Bookings',
          lbl_booking: 'Booking',
          lbl_add_transportation_mode: 'Add Transportation Mode',
          lbl_edit_transportation_mode: 'Edit Transportation Mode',
          lbl_transportation_mode_added_successfully: 'Transportation Mode Added Successfully',
          lbl_transportation_mode_updated_successfully: 'Transportation Mode Updated Successfully',
          lbl_transportation_mode_delete_successfully: 'Transportation Mode Deleted Successfully',
          lbl_transportation_modes_delete_successfully: 'Transportation Modes Deleted Successfully',
          lbl_add_luggage: 'Add Luggage',
          lbl_edit_luggage: 'Edit Luggage',
          lbl_luggage_added_successfully: 'Luggage Added Successfully',
          lbl_luggage_updated_successfully: 'Luggage Updated Successfully',
          lbl_luggage_delete_successfully: 'Luggage Deleted Successfully',
          lbl_add_journey_preference: 'Add Journey Preference',
          lbl_edit_journey_preference: 'Edit Journey Preference',
          lbl_journey_preference_added_successfully: 'Journey Preference Added Successfully',
          lbl_journey_preference_updated_successfully: 'Journey Preference Updated Successfully',
          lbl_journey_preference_delete_successfully: 'Journey Preference Deleted Successfully',
          lbl_journey_preferences_delete_successfully: 'Journey Preferences Deleted Successfully',
          lbl_add_vehicle_body_type: 'Add Vehicle Body Type',
          lbl_edit_vehicle_body_type: 'Edit Vehicle Body Type',
          lbl_vehicle_body_type_added_successfully: 'Vehicle Body Type Added Successfully',
          lbl_vehicle_body_type_updated_successfully: 'Vehicle Body Type Updated Successfully',
          lbl_vehicle_body_type_delete_successfully: 'Vehicle Body Type Deleted Successfully',
          lbl_vehicle_body_types_delete_successfully: 'Vehicle Body Types Deleted Successfully',
          lbl_add_vehicle_dispatch: 'Add Vehicle Dispatch',
          lbl_edit_vehicle_dispatch: 'Edit Vehicle Dispatch',
          lbl_vehicle_dispatch_added_successfully: 'Vehicle Dispatch Added Successfully',
          lbl_vehicle_dispatch_updated_successfully: 'Vehicle Dispatch Updated Successfully',
          lbl_vehicle_dispatch_delete_successfully: 'Vehicle Dispatch Deleted Successfully',
          lbl_vehicles_dispatch_delete_successfully: 'Vehicles Dispatch Deleted Successfully',
          transportation_mode_delete_header: 'Confirm Delete Transportation Mode',
          transportation_type_delete_header: 'Confirm Delete Transportation Type',
          luggage_delete_header: 'Confirm Delete Luggage',
          journey_preference_delete_header: 'Confirm Delete Journey Preference',
          vehicle_body_type_delete_header: 'Confirm Delete Vehicle Body Type',
          vehicle_dispatch_delete_header: 'Confirm Delete Vehicle Dispatch',
          delete_msg: 'Are you sure you want to delete this records? Deleting a record does not remove it from system, but it will no longer be usable.',
        },
        events: {
          lbl_event: 'Event',
          lbl_events: 'Events',
          lbl_add_transportation_type: 'Add Transportation Type',
          lbl_edit_transportation_type: 'Edit Transportation Type',
          lbl_transportation_type_added_successfully: 'Transportation Type Added Successfully',
          lbl_transportation_type_updated_successfully: 'Transportation Type Updated Successfully',
          lbl_transportation_type_delete_successfully: 'Transportation Type Deleted Successfully',
          lbl_transportation_types_delete_successfully: 'Transportation Types Deleted Successfully',
          transportation_type_delete_header: 'Confirm Delete Transportation Type',
          delete_msg: 'Are you sure you want to delete this records? Deleting a record does not remove it from system, but it will no longer be usable.',
        },
        passenger: {
          lbl_passengers: 'Passengers',
          lbl_passenger: 'Passenger',
          lbl_add_passenger_type: 'Add Passenger Type',
          lbl_edit_passenger_type: 'Edit Passenger Type',
          lbl_passenger_type_added_successfully: 'Passenger Type Added Successfully',
          lbl_passenger_type_updated_successfully: 'Passenger Type Updated Successfully',
          lbl_passenger_type_delete_successfully: 'Passenger Type Deleted Successfully',
          lbl_passenger_types_delete_successfully: 'Passenger Types Deleted Successfully',
          lbl_add_passenger_status: 'Add Passenger Status',
          lbl_edit_passenger_status: 'Edit Passenger Status',
          lbl_add_privilege_settings: 'Add Privilege Settings',
          lbl_view_edit_privilege_settings: 'View / Edit Privilege Settings',
          lbl_passenger_status_added_successfully: 'Passenger Status Added Successfully',
          lbl_passenger_status_updated_successfully: 'Passenger Status Updated Successfully',
          lbl_passenger_status_delete_successfully: 'Passenger Status Deleted Successfully',
          passenger_type_delete_header: 'Confirm Delete Passenger Type',
          passenger_status_delete_header: 'Confirm Delete Passenger Status',
          passenger_privilege_header: 'Confirm Delete Passenger Type',
          lbl_added_privilege_settings_success: 'Privilege Settings Added Successfully',
          lbl_updated_privilege_settings_success: 'Privilege Settings Updated Successfully',
          delete_msg: 'Are you sure you want to delete this records? Deleting a record does not remove it from system, but it will no longer be usable.',
          title: 'Title',
          data_type: 'Data Type',
          required: 'Required',
          settings_section: 'Settings Section',
          settings_section_p: 'Settings section will content set of data which will enable Privileges for passenger',
          privileges: 'Privileges',
          privilege_section_p: 'List of privileges under selected section',
          privilege_edit_p: 'Customize privileges data for selected Privilege',
          content: 'Content',
          add_other_option: `Add option of "Other"`,
          requiredField: 'Required Field',
          you_can_add: 'You can add multiple items',
          clear: 'Clear',
          edit: 'Edit',
          info_text: 'Information Text',
          note: 'Note',
          required_field: 'Required Field',
          yes: 'Yes',
          no: 'No',
          default_values_placeholder: 'Set default values for selected player type',
        },
        vehicle: {
          lbl_vehicle: 'Vehicle',
          lbl_add_vehicle_type: 'Add Vehicle Type',
          lbl_edit_vehicle_type: 'Edit Vehicle Type',
          lbl_vehicle_type_added_successfully: 'Vehicle Type Added Successfully',
          lbl_vehicle_type_updated_successfully: 'Vehicle Type Updated Successfully',
          lbl_vehicle_type_delete_successfully: 'Vehicle Type Deleted Successfully',
          lbl_vehicle_types_delete_successfully: 'Vehicle Types Deleted Successfully',
          lbl_add_vehicle_status: 'Add Vehicle Status',
          lbl_edit_vehicle_status: 'Edit Vehicle Status',
          lbl_vehicle_status_added_successfully: 'Vehicle Status Added Successfully',
          lbl_vehicle_status_updated_successfully: 'Vehicle Status Updated Successfully',
          lbl_vehicle_status_delete_successfully: 'Vehicle Status Deleted Successfully',
          lbl_vehicles_status_delete_successfully: 'Vehicles Status Deleted Successfully',
          vehicle_type_delete_header: 'Confirm Delete Vehicle Type',
          vehicle_status_delete_header: 'Confirm Delete Vehicle Status',
          lbl_add_body_types: 'Add Body Types',
          lbl_edit_body_types: 'Edit Body Types',
          lbl_body_type_added_successfully: 'Body Type Added Successfully',
          lbl_body_type_updated_successfully: 'Body Type Updated Successfully',
          lbl_body_type_delete_successfully: 'Body Type Deleted Successfully',
          lbl_body_types_delete_successfully: 'Body Types Deleted Successfully',
          lbl_add_features: 'Add Features',
          lbl_edit_features: 'Edit Features',
          lbl_features_added_successfully: 'Feature Added Successfully',
          lbl_feature_updated_successfully: 'Feature Updated Successfully',
          lbl_feature_delete_successfully: 'Feature Deleted Successfully',
          lbl_features_delete_successfully: 'Features Deleted Successfully',
          body_type_delete_header: 'Confirm Delete Body Type',
          features_delete_header: 'Confirm Delete Features',
          delete_msg: 'Are you sure you want to delete this records? Deleting a record does not remove it from system, but it will no longer be usable.',
        },
        driver: {
          lbl_driver: 'Driver',
          lbl_drivers: 'Drivers',
          lbl_add_driving_record: 'Add Driving Record',
          lbl_edit_driving_record: 'Edit Driving Record',
          lbl_driving_record_added_successfully: 'Driving Record Added Successfully',
          lbl_driving_record_updated_successfully: 'Driving Record Updated Successfully',
          lbl_driving_record_delete_successfully: 'Driving Record Deleted Successfully',
          lbl_driving_records_delete_successfully: 'Driving Records Deleted Successfully',
          driving_record_delete_header: 'Confirm Delete Driving Record',
          lbl_add_duty_status: 'Add Duty Status',
          lbl_edit_duty_status: 'Edit Duty Status',
          lbl_duty_status_added_successfully: 'Duty Status Added Successfully',
          lbl_duty_status_updated_successfully: 'Duty Status Updated Successfully',
          lbl_duty_status_delete_successfully: 'Duty Status Deleted Successfully',
          duty_status_delete_header: 'Confirm Delete Duty Status',
          lbl_add_reason_for_duty_status: 'Add Reason For Duty Status',
          lbl_edit_reason_for_duty_status: 'Edit Reason For Duty Status',
          lbl_reason_for_duty_status_added_successfully: 'Reason For Duty Status Added Successfully',
          lbl_reason_for_duty_status_updated_successfully: 'Reason For Duty Status Updated Successfully',
          lbl_reason_for_duty_status_delete_successfully: 'Reason For Duty Status Deleted Successfully',
          lbl_reasons_for_duty_status_delete_successfully: 'Reasons For Duty Status Deleted Successfully',
          reason_for_duty_status_delete_header: 'Confirm Delete Reason For Duty Status',
          lbl_leave: 'Leave',
          lbl_leaves: 'Leaves',
          lbl_add_leave_type: 'Add Leave Type',
          lbl_edit_leave_type: 'Edit Leave Type',
          lbl_leave_type_added_successfully: 'Leave Type Added Successfully',
          lbl_leave_type_updated_successfully: 'Leave Type Updated Successfully',
          lbl_leave_type_delete_successfully: 'Leave Type Deleted Successfully',
          lbl_leave_types_delete_successfully: 'Leave Types Deleted Successfully',
          leave_type_delete_header: 'Confirm Delete Leave Type',
          delete_msg: 'Are you sure you want to delete this records? Deleting a record does not remove it from system, but it will no longer be usable.',
        },
        location: {
          lbl_location: 'Location',
          lbl_locations: 'Locations',
          lbl_zones: 'Zones',
          lbl_zone: 'Zone',
          lbl_add_location_status: 'Add Location Status',
          lbl_edit_location_status: 'Edit Location Status',
          lbl_location_status_added_successfully: 'Location Status Added Successfully',
          lbl_location_status_updated_successfully: 'Location Status Updated Successfully',
          lbl_location_status_delete_successfully: 'Location Status Deleted Successfully',
          location_status_delete_header: 'Confirm Delete Location Status',
          lbl_add_location_category: 'Add Location Category',
          lbl_edit_location_category: 'Edit Location Category',
          lbl_location_category_added_successfully: 'Location Category Added Successfully',
          lbl_location_category_updated_successfully: 'Location Category Updated Successfully',
          lbl_location_category_delete_successfully: 'Location Category Deleted Successfully',
          location_category_delete_header: 'Confirm Delete Location Category',
          lbl_add_dispatch_zone: 'Add Dispatch Zone',
          lbl_edit_dispatch_zone: 'Edit Dispatch Zone',
          lbl_dispatch_zone_added_successfully: 'Dispatch Zone Added Successfully',
          lbl_dispatch_zone_updated_successfully: 'Dispatch Zone Updated Successfully',
          lbl_dispatch_zone_delete_successfully: 'Dispatch Zone Deleted Successfully',
          dispatch_zone_delete_header: 'Confirm Delete Dispatch Zone',
          delete_msg: 'Are you sure you want to delete this records? Deleting a record does not remove it from system, but it will no longer be usable.',
        },
        incidents_complaints: {
          lbl_incidents_complaints: 'Incidents & Complaints',
          lbl_incident_complaint: 'Incident & Complaint',
          lbl_incidents_complaints_status: 'Incidents & Complaints Status',
          lbl_add_status: 'Add Status',
          lbl_add_incidents_complaint_status: 'Add Incidents & Complaints Status',
          lbl_edit_incidents_complaint_status: 'Edit Incidents & Complaints Status',
          lbl_incidents_complaint_status_added_successfully: 'Status Added Successfully',
          lbl_incidents_complaint_status_updated_successfully: 'Status Updated Successfully',
          lbl_incidents_complaint_status_delete_successfully: 'Status Deleted Successfully',
          incidents_complaint_status_delete_header: 'Confirm Delete Status',
          lbl_add_category: 'Add Category',
          lbl_add_incidents_complaint_category: 'Add Incidents & Complaints Category',
          lbl_edit_incidents_complaint_category: 'Edit Incidents & Complaints Category',
          lbl_incidents_complaint_category_added_successfully: 'Category Added Successfully',
          lbl_incidents_complaint_category_updated_successfully: 'Category Updated Successfully',
          lbl_incidents_complaint_category_delete_successfully: 'Category Deleted Successfully',
          incidents_complaint_category_delete_header: 'Confirm Delete Category',
          lbl_add_type: 'Add Type',
          lbl_add_raised_by_type: 'Add Raised by Type',
          lbl_edit_raised_by_type: 'Edit Raised by Type',
          lbl_raised_by_type_added_successfully: 'Raised by Type Added Successfully',
          lbl_raised_by_type_updated_successfully: 'Raised by Type Updated Successfully',
          lbl_raised_by_type_delete_successfully: 'Raised by Type Deleted Successfully',
          raised_by_type_delete_header: 'Confirm Delete Raised by Type  ',
          delete_msg: 'Are you sure you want to delete this records? Deleting a record does not remove it from system, but it will no longer be usable.',
          lbl_status_delete_successfully: 'Status deleted successfully',
          lbl_incident_status_add: 'Status added successfully',
        },
        shift_management: {
          lbl_groups: 'Groups',
          lbl_group: 'Group',
          lbl_add_driver_group_status: 'Add Driver Group Status',
          lbl_edit_driver_group_status: 'Edit Driver Group Status',
          lbl_driver_group_status_added_successfully: 'Driver Group Status Added Successfully',
          lbl_driver_group_status_updated_successfully: 'Driver Group Status Updated Successfully',
          lbl_driver_group_status_delete_successfully: 'Driver Group Status Deleted Successfully',
          driver_group_status_delete_header: 'Confirm Delete Driver Group Status',
          lbl_group_color: 'Group Color',
          lbl_add_driver_color: 'Add Group Color',
          lbl_edit_driver_color: 'Edit Group Color',
          lbl_driver_color_added_successfully: 'Group Color Added Successfully',
          lbl_driver_color_updated_successfully: 'Group Color Updated Successfully',
          lbl_driver_color_delete_successfully: 'Group Color Deleted Successfully',
          lbl_drivers_color_delete_successfully: 'Group Colors Deleted Successfully',
          driver_color_delete_header: 'Confirm Delete Group Color',
          lbl_shift: 'Shift',
          lbl_shifts: 'Shifts',
          lbl_reason_for_break: 'Reason For Break',
          lbl_add_reason_for_break: 'Add Reason For Break',
          lbl_edit_reason_for_break: 'Edit Reason For Break',
          lbl_reason_for_break_added_successfully: 'Reason For Break Added Successfully',
          lbl_reason_for_break_updated_successfully: 'Reason For Break Updated Successfully',
          lbl_reason_for_break_delete_successfully: 'Reason For Break Deleted Successfully',
          lbl_reason_for_breaks_delete_successfully: 'Reason For Breaks Deleted Successfully',
          reason_for_break_delete_header: 'Confirm Delete Reason For Break',
          delete_msg: 'Are you sure you want to delete this records? Deleting a record does not remove it from system, but it will no longer be usable.',
        },
        communication: {
          lbl_messages: 'Messages',
          lbl_message: 'Message',
          lbl_add_message_type: 'Add Message Type',
          lbl_edit_message_type: 'Edit Message Type',
          lbl_message_type_added_successfully: 'Message Type Added Successfully',
          lbl_message_type_updated_successfully: 'Message Type Updated Successfully',
          lbl_message_type_delete_successfully: 'Message Type Deleted Successfully',
          message_type_delete_header: 'Confirm Delete Message Type',
          lbl_add_select_time: 'Add Select Time',
          lbl_edit_select_time: 'Edit Select Time',
          lbl_select_time_added_successfully: 'Select Time Added Successfully',
          lbl_select_time_updated_successfully: 'Select Time Updated Successfully',
          lbl_select_time_delete_successfully: 'Select Time Deleted Successfully',
          select_time_delete_header: 'Confirm Delete Select Time',
          delete_msg: 'Are you sure you want to delete this records? Deleting a record does not remove it from system, but it will no longer be usable.',
        },
        labels: {
          lbl_label: 'Label',
          lbl_add_label: 'Add Label',
          lbl_edit_label: 'Edit Label',
          lbl_label_added_successfully: 'Label Added Successfully',
          lbl_label_updated_successfully: 'Label Updated Successfully',
          lbl_label_delete_successfully: 'Label Deleted Successfully',
          label_delete_header: 'Confirm Delete Label',
          delete_msg: 'Are you sure you want to delete this records? Deleting a record does not remove it from system, but it will no longer be usable.',
        },
        custom_fields: {
          lbl_custom_fields_upper: 'CUSTOM FIELDS',
          lbl_these_custom_fields_text: 'These custom fields will reflect in chosen services is shown',
          lbl_details_upper: 'DETAILS',
          lbl_customize_how_you_want_to_show_text: 'Customize how you want to show the data in this field',
          lbl_no_custom_fields_added: 'No Custom Field added',
          lbl_add_first_custom_field: 'Add first Custom Field',
          lbl_add_custom_fields_btn: 'Add Custom Fields',
          lbl_add_new: 'Add New',
          lbl_delete_highlight_illness: 'Delete Highlight illness',
          lbl_delete_confirm_message: 'Are you sure you want to delete this custom field data?',
          lbl_clear: 'Clear',
          lbl_select_the_module_text: 'Select the module where you want to show this field',
          lbl_all_modules: 'Select Module',
          lbl_select_sub_module: 'Select Sub-Module',
          lbl_module: 'Module',
          lbl_sub_module: 'Sub Module',
          lbl_tab: 'Tab',
          lbl_sections: 'Section',
          lbl_data_type: 'Data Type',
          lbl_select_the_type_text: 'Select the type of field you want as input',
          lbl_content: 'Content',
          lbl_you_can_add_multiple_items: 'You can add multiple items',
          lbl_add_option_of_other: 'Add option of "Other"',
          lbl_allow_action: 'Allow Action',
          lbl_search: 'Search',
          lbl_advance_filters: 'Advance Filters',
          lbl_manage_columns: 'Manage Columns',
          lbl_information_text: 'Information Text',
          lbl_additional_details_about_this_field_text: 'Additional details about this field. This will appear when a user hovers on ',
          lbl_note: 'Note',
          lbl_this_note_is_to_get_more_information_text: 'This note is to get more information and this will appear at the bottom of data type',
          lbl_validation: 'Validation',
          lbl_required_field: 'Required Field',
          lbl_please_select: 'Please Select',
          lbl_module_required: 'Module is required',
          lbl_data_type_required: 'Data type is required',
          lbl_content_required: 'Content is required',
          lbl_note_required: 'Note is required',
          custom_field_added_successfully: 'Custom field added successfully',
          confirm_delete_header: 'Confirm Delete Custom Fields',
          lbl_alphabets_allowed: 'Alphabets Allowed',
          lbl_numbers_allowed: 'Numbers Allowed',
          lbl_special_characters_allowed: 'Special Characters Allowed',
          lbl_information_text_required: 'Information text is required',
          lbl_tab_required: 'Tab is required',
          lbl_section_required: 'Section is required',
          lbl_only_available_for_tab: '(Only available for tab 1)',
        },
        authentication: {
          header: 'Authentication',
          user: 'User',
          driver: 'Driver',
          passenger: 'Passenger',
          password_is_required: 'Password is required.',
          lbl_password_updated_successfully: 'Password Updated Successfully',
          lbl_password_pattern_error: 'The password must be at least 8 characters long, contain a mix of uppercase and lowercase letters, numbers, and special characters, and avoid sequences like "1234" or "abcd."',
          lbl_description: '(OTP will be send on Registered Contact Number or Email Address)',
          lbl_session_timeout: 'SESSION TIMEOUT',
          lbl_session_description: 'Control how long users can be inactive before automatically signed out.',
          lbl_mobile_app: 'Mobile APP',
          lbl_select_an_option: 'Select an option',
          password_help_text: 'Password will be send on Registered Email Address',
          lbl_meta_url: 'Meta URL',
          lbl_enter_meta_url: 'Enter meta URL for SSO',
          lbl_error_meta_url_required: 'Meta URL is required',
          lbl_select_at_least_one_option: 'Please select at least one login option'
        },
        notification: {
          lbl_notification_event: 'Notification Event',
          lbl_email_address: 'Email Address',
          lbl_push: 'Push',
          lbl_sms: 'SMS',
          confirm_delete_header: 'Confirm Change Notification Config',
          confirm_delete_msg: '<p></p><p>Are you sure you want to change this notification config?</p><p></p>',
          notification_config_successfully: 'Notification config updated successfully',
          notification_matrix_successfully: 'Notification matrix updated successfully',
          confirm_discard_header: 'Are you sure you want to discard the changes?',
          lbl_confirmation: 'Confirmation',
        }
      },
      sponsor: {
        lbl_edit: 'Edit',
        lbl_status: 'Status',
        lbl_billing_entity: 'Billing Entity',
        lbl_abn_number: 'ABN Number',
        lbl_account_number: 'Account Number',
        lbl_contact_number: 'Account Contact Number',
        lbl_contact_email: 'Account Contact Email',
        lbl_id: 'ID',
        lbl_full_legal_name: 'Full Legal Name',
        lbl_postal_address: 'Postal Address',
        lbl_phone_number: 'Phone Number',
        lbl_email_address: 'Email Address',
        lbl_overview: 'Overview',
        lbl_protocols: 'Protocols ',
        lbl_users: 'Users ',
        lbl_save_sponsor: 'Save Sponsor',
        lbl_update_sponsor: 'Update Sponsor',
        lbl_sponsor_details: 'Sponsor Details',
        lbl_billing_details: 'Billing Details',
        confirm_delete_msg: '<p></p><p>Are you sure you want to delete this Sponsor?</p><p><b>Once deleted, it can\'t be undone.</b></p><p></p>',
        delete_sponsor: 'Delete Sponsor',
        cancel: 'Cancel',
        confirm_delete_header: 'Confirm Delete Sponsor',
        sponsor_delete_success: 'Sponsor Deleted Successfully',
        lbl_sponsor_updated_successfully: 'Sponsor Updated Successfully',
        lbl_sponsor_added_successfully: 'Sponsor Added Successfully',
        lbl_activate: 'Activate',
        lbl_deactivate: 'Deactivate',
        msg_activate_confirmation: '<p></p><p>Are you sure you want to activate this sponsor?</p>',
        msg_deactivate_confirmation: '<p></p><p>Are you sure you want to deactivate this sponsor?</p>',
        lbl_activate_sponsor: 'Activate Sponsor',
        lbl_deactivate_sponsor: 'Deactivate Sponsor',
        lbl_active_protocols: 'Active Protocols',
        lbl_invite_user: 'Invite User',
        msg_deactivated_successfully: 'Sponsor Deactivated Successfully',
        msg_activated_successfully: 'Sponsor Activated Successfully',
      },
      patient: {
        lbl_add_patient: 'Add Patient',
        lbl_edit: 'Edit',
        lbl_edit_patient: 'Edit Patient',
        lbl_update_patient: 'Update Patient',
        lbl_patient_added_successfully: 'Patient Added Successfully',
        lbl_patient_updated_successfully: 'Patient Updated Successfully',
        lbl_pause: 'Pause',
        lbl_update_pause: 'Update Pause',
        lbl_remove_pause: 'Remove Pause',
        lbl_update_pause_patient: 'Update Pause Patient',
        lbl_off_trial: 'Off Trial',
        lbl_on_trial: 'On Trial',
        lbl_pause_patient_participation: 'Pause Patient Participation',
        lbl_update_pause_patient_participation: 'Update Pause Patient Participation',
        lbl_remove_pause_patient: 'Remove Pause Patient',
        msg_remove_pause_patient_participation: 'Are you sure you want to remove the pause for this patient?',
        msg_pause_removed_successfully: 'Patient pause removed successfully',
        msg_pause_updated_successfully: 'Patient pause updated successfully',
        msg_pause_patient_participation_note: 'You are about to pause this patient from participating in the protocols. During this period, no orders or actions can be performed for this patient.',
        lbl_days: 'Days',
        error_end_date_greater: 'End date must be greater than from date',
        error_from_date_required: 'From date is required',
        error_end_date_required: 'End date is required',
        confirm_delete_msg:
          "<p></p><p>Are you sure you want to delete this Patient?</p><p><b>Once deleted, it can't be undone. The patient needs to be added again.</b></p><p></p>",
        delete_patient: 'Delete Patient',
        msg_change_trial_to_off_trial: 'Are you sure you want to mark this patient trial status as Off Trial?',
        msg_change_trial_to_on_trial: 'Are you sure you want to mark this patient trial status as On Trial?',
        msg_remove_pause_before_on_trial: 'This patient is currently paused. Please remove the pause before changing the status to On Trial.',
        lbl_change_trial_status: 'Change Trial Status',
        lbl_pause_patient: 'Pause Patient',
        lbl_to: 'To',
        msg_patient_status_changed_to_on_trial: 'Patient Trial Status Changed to On Trial.',
        msg_patient_status_changed_to_off_trial: 'Patient Trial Status Changed to Off Trial.',
        lbl_download_patient: 'Import Patients',
        lbl_download_template: 'Download Import Template',
        lbl_download_guide: 'Download Import Guide',
        lbl_search_by_patient_id: 'Search by Patient ID',
        lbl_patient_id: 'Patient ID',
      },
      patient_selection: {
        header: 'Select Patients',
        available_patients: 'Available Patients',
        selected_patients: 'Selected Patients',
        name: 'Name',
        patient_id: 'Patient ID',
        action: 'Action',
        cancel: 'Cancel',
        save: 'Save',
      },
    });
  }
}
